<template>
  <!-- 活动管理 -->
  <div class="activityManage">
    <div class="activityManage-list" v-show="createStep == 1">
      <jd-subTab
        :options="tabSwitchListData"
        @input="handleTab"
        :value="currIndex"
        class="mb16"
      >
      </jd-subTab>
      <!-- <div class="activityManage-list-scroll"> -->
        <jd-form
          :formData.sync="form"
          :formInfo="searchFormInfo"
          :emitReset="true"
          ref="formRef"
          @search="handkeSearch($event, 0)"
          @reset="handkeSearch($event, 1)"
          v-show="actItemInfo"
        >
          <template #activityType>
            <el-select
              v-model="form.activityType"
              placeholder="请选择"
              filterable
              style="width: 280px"
            >
              <el-option
                v-for="item in selectArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
        </jd-form>
      <!-- </div> -->
      <!-- <div class="new-bottom-bg-box" style="padding: 20px"> -->
        <div class="mb12 mt16" v-if="inventorytip">
          <jd-tip>
           <div class="inventory-tip">
            {{ inventorytip }}
           </div>
          </jd-tip>
        </div>
        <div
        class="mt16 flex-spc-x-end">
          <div v-if="mainTypes == 1">
            <jd-button type="blueLine" @click="handleSetConfig"
            >活动配置</jd-button
            >
            <jd-button @click="handleAIResource"
              >我的AI资源</jd-button
            >
          </div>
          <div class="tip-style" v-else>提前创建活动非100%创建成功，与其他平台&官方创建的活动的时间重叠时，会出现创建失败情况，请注意避免此状况发生。</div>
          <div class="table_tip_right">
            <el-checkbox v-model="form.createByMe" @change="handleCreateByMe"
              >我创建的</el-checkbox
            >
            <!-- <div
              v-if="mainTypes == 1"
              class="win_search fs12"
              @click="handleWinSearch"
            >
              中奖查询
            </div> -->
            <jd-button type="blueText" @click="handleWinSearch" style="margin-left: 20px;">中奖查询</jd-button>
          </div>
        </div>
        <!-- 表格内容 -->
        <template v-if="activityPlusMainTypes == 6">
          <giftList
            ref="giftList"
            :statisType="2"
            :inputShow="false"
            @statisDataCreate="statisDataCreate"
            @handleshow="handleshow"
          ></giftList>
        </template>
        <template v-else-if="activityPlusMainTypes == 7">
          <member ref="member" @handleAnysis="handleAnysis"></member>
        </template>

        <template v-else>
          <jd-table
            :tableData="activityList"
            :loading="talbeLoading"
            style="width: 100%; margin-top: 12px"
            ref="table"
            :pageInfo="{
              pageNum: recordData.current,
              pageSize: recordData.size,
              noShow: false,
              total: totalNum,
            }"
            @handlePage="handlePages"
          >
            <el-table-column label="活动名称" width="280">
              <template slot-scope="scope">
                <div class="activityName">
                  <el-tooltip
                    effect="light"
                    :content="scope.row.activityName"
                    placement="top"
                    v-if="scope.row.activityType == 41"
                  >
                    <div class="act-name">{{ scope.row.activityName }}</div>
                  </el-tooltip>
                  <span v-else class="fs12">{{ scope.row.activityName }}</span>
                  <el-popover
                    v-if="currIndex != 5 && scope.row.activityType !== 43"
                    placement="right-end"
                    :width="getPopoverWidth(scope.row.activityType)"
                    trigger="hover"
                    :height="700"
                  >
                  <!-- 下单有礼和满额有礼跨店扫描 -->
                  <jd-subTab
                    v-if="showCannel(scope.row.activityType)"
                    :options="tabSwitchListDatas" 
                    @input="handleTabs($event,scope.row)" 
                    :value="currIndexs">
                  </jd-subTab>
                  <div v-show="currIndexs == 0">
                      <div style="margin: 20px; text-align: center">
                      请用手机京东扫描下面二维码查看您店铺的活动详情
                    </div>
                    <!-- <img src="" alt="活动二维码" style="margin-left: 60px" /> -->
                    <!-- <div class="qrcode" :id="'qrcode' + scope.row.id" :ref="'qrcode' + scope.row.id" style="margin-left: 80px"></div> -->
                    <qrcode-vue
                      class="qrcode"
                      :id="'qrcode' + scope.row.id"
                      :ref="'qrcode' + scope.row.id"
                      :size="qrcodeVue.size"
                      :value="scope.row.idUrl"
                      :logo="qrcodeVue.logo"
                      :bgColor="qrcodeVue.bgColor"
                      :fgColor="qrcodeVue.fgColor"
                      style="text-align: center"
                    ></qrcode-vue>
                    <div>
                      <div style="margin: 20px; text-align: center">
                        链接地址：<span style="color: #999999"
                          >(手机京东店铺中活动详情链接地址)</span
                        >
                      </div>
                      <el-input
                        v-if="scope.row.pcUrl"
                        readonly
                        v-model="scope.row.pcUrl"
                        :style="`margin: 0 20px; width: ${getInputWidth(scope.row.activityType)}px`"
                      ></el-input>
                      <el-input
                        v-else
                        readonly
                        v-model="scope.row.idUrl"
                        :style="`margin: 0 20px; width: ${getInputWidth(scope.row.activityType)}px`"
                      ></el-input>
                      <el-button
                        type="primary"
                        style="border-radius: 4px"
                        v-clipboard:copy="scope.row.pcUrl || scope.row.idUrl"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                        >复制</el-button
                      >
                      <el-button
                        type="primary"
                        style="border-radius: 4px"
                        @click="handleSrcImg(scope.row.id)"
                        >下载二维码</el-button
                      >
                    </div>    
                    <!-- 活动链接 -->
                    <div style="margin-top: 10px;margin-left: 17px;">
                     <span>活动短链接:</span>
                     <el-input
                        disabled
                        readonly
                        :value="scope.row.shortLink || '生成中...'"
                        :style="`margin: 0 5px; width:200px`"
                      ></el-input>&nbsp;&nbsp;&nbsp;&nbsp;
                      <el-button
                        type="primary"
                        style="border-radius: 4px"
                        v-clipboard:copy="scope.row.shortLink || scope.row.pcUrl || scope.row.idUrl"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                        >复制</el-button>
                    </div>
                  </div>
                  <div v-show="currIndexs == 1" class="channelBox">
                    <div style="margin: 10px 0;">
                      <jd-tip>注:仅设置了多店铺的活动有数据，目前支持多店铺设置的玩法有：满额有礼、下单抽奖、下单有礼、复购有礼、首单专享礼</jd-tip>
                    </div>
                    <el-form :model="scope.row" v-if="[19,16,17,18].includes(scope.row.activityType)&&tableDatas.length">
                      <!-- 功能迁移至活动内部配置 -->
                      <!-- <el-form-item label="小程序所属店铺名称">
                        <el-radio-group v-model="shopNameType" @change="changeShop($event,scope.row)">
                          <el-radio
                            :label="0"
                            >统一显示配置活动店铺</el-radio
                          >
                          <el-radio
                            :label="1"
                            >根据店铺渠道显示所属店铺名称</el-radio
                          >
                        </el-radio-group>
                      </el-form-item> -->
                    </el-form>
                    <jd-table 
                      key="channel-table"
                      :noShow="true"
                      :tableData="tableDatas"
                      :tableInfo="tableChannelInfo"
                      :loading="tableLodingCurrIndexOne"
                      >
                      <!-- 二维码列的插槽 -->
                      <template #qrCode="{ row }">
                        <!-- 表格显示用的小二维码 -->
                        <div class="qrcode-container" @mouseenter="showMask = row.id" @mouseleave="showMask = null">
                          <qrcode-vue class="qrcode" :id="'channelQrcode' + row.id" :ref="'qrcode' + row.id"
                            :size="40" :value="getLinkUrl(row)" :logo="qrcodeVue.logo" :bgColor="qrcodeVue.bgColor"
                            :fgColor="qrcodeVue.fgColor" style="text-align: center;margin-top: 10px;"></qrcode-vue>
                          <!-- 遮罩层 -->
                          <div v-if="showMask === row.id" class="qrcode-mask" @click="showQrcodeDialog(row)">
                            <i class="el-icon-zoom-in qrcode-zoom-icon"></i>
                          </div>
                        </div>
                        <!-- 下载用的大二维码（隐藏） -->
                        <qrcode-vue class="qrcode-download" :id="'channelQrcodeDownload' + row.id" :size="200"
                          :value="getLinkUrl(row)" :logo="qrcodeVue.logo" :bgColor="qrcodeVue.bgColor"
                          :fgColor="qrcodeVue.fgColor"
                          style="position: absolute; left: -9999px; top: -9999px;"></qrcode-vue>
                      </template>
                      <!-- 链接地址 -->
                        <template #linkUrls="{ row }">
                        <el-tooltip class="item" :content="getLinkUrl(row)" placement="top">
                          <div style="width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ getLinkUrl(row) }}</div>
                        </el-tooltip>
                        </template>
                        
                      <template #action="{ row }">
                        <jd-button type="blueText" @click="copyChannelUrl(getLinkUrl(row))">复制链接</jd-button>
                        <jd-button type="blueText"
                          @click="handleSrcImg(row.id, type = 'channel')">下载二维码</jd-button>
                      </template>
                    </jd-table>
                  </div>
                  <div v-show="currIndexs == 2" class="channelBox">
                    <div style="margin: 10px 0;">
                      <jd-button type="blue" @click="handleAddChannel(scope.row.activityType)">添加渠道链接</jd-button>&nbsp;
                      <span>注:多渠道投放活动时可自定义生成渠道链接，后续可追踪不同渠道投放的数据。</span>
                    </div>
                    <jd-table 
                      key="channel-table"
                      :noShow="true"
                      :tableData="tableDatas2"
                      :tableInfo="tableSelfInfo"
                      :loading="tableLodingCurrIndexTwo"
                      >
                      <!-- 店铺名称列的插槽 -->
                      <template #shopName="{ row }">
                        {{ row.sellerLinkName || '店铺名称' }}
                      </template>
                      <!-- 链接地址列的插槽 -->
                      <template #linkUrl="{ row }">
                        <el-tooltip class="item" :content="getLinkUrl(row)" placement="top">
                          <div style="width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ getLinkUrl(row) }}</div>
                        </el-tooltip>
                      </template>
                      <!-- 二维码列的插槽 -->
                      <template #qrCode="{ row }">
                        <!-- 表格显示用的小二维码 -->
                        <div class="qrcode-container" @mouseenter="showMask = row.id" @mouseleave="showMask = null">
                          <qrcode-vue class="qrcode" :id="'selfQrcode' + row.id" :ref="'qrcode' + row.id"
                            :size="40" :value="getLinkUrl(row)" :logo="qrcodeVue.logo" :bgColor="qrcodeVue.bgColor"
                            :fgColor="qrcodeVue.fgColor" style="text-align: center;margin-top: 10px;"></qrcode-vue>
                          <!-- 遮罩层 -->
                          <div v-if="showMask === row.id" class="qrcode-mask" @click="showQrcodeDialog(row)">
                            <i class="el-icon-zoom-in qrcode-zoom-icon"></i>
                          </div>
                        </div>
                        <!-- 下载用的大二维码（隐藏） -->
                        <qrcode-vue class="qrcode-download" :id="'selfQrcodeDownload' + row.id" :size="200"
                          :value="getLinkUrl(row)" :logo="qrcodeVue.logo" :bgColor="qrcodeVue.bgColor"
                          :fgColor="qrcodeVue.fgColor"
                          style="position: absolute; left: -9999px; top: -9999px;"></qrcode-vue>
                      </template>
                      <!-- 操作列的插槽 -->
                      <template #action="{ row }">
                        <jd-button type="blueText" @click="copyChannelUrl(getLinkUrl(row))">复制链接</jd-button>
                        <jd-button type="blueText" @click="handleSrcImg(row.id, type = 'self')">下载二维码</jd-button>
                      </template>
                    </jd-table>
                  </div>
                  <!-- 列表图片 -->
                  <img
                      v-if="
                        scope.row.activityType != 13 &&
                        scope.row.activityType != 14 &&
                        scope.row.activityType != 15 &&
                        scope.row.activityType != 63 &&
                        scope.row.activityType != 74 &&
                        scope.row.activityType != 75
                      "
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/list_code.png"
                      alt="活动二维码"
                      class="code"
                      slot="reference"
                      @mouseenter="handlerMouseEnter(scope.row.id)"
                    />
                  </el-popover>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="活动类型">
              <template slot-scope="scope">
                <span v-if="scope.row.activityType == 1"> 签到赢好礼</span>
                <span v-if="scope.row.activityType == 2"> 浏览礼品有礼 </span>
                <span v-if="scope.row.activityType == 3"> 每日限时抢 </span>
                <span v-if="scope.row.activityType == 4"> 关注店铺有礼 </span>
                <span v-if="scope.row.activityType == 5"> 邀请开卡有礼 </span>
                <span v-if="scope.row.activityType == 6"> 邀请关注有礼 </span>
                <span v-if="scope.row.activityType == 7"> 完善信息有礼 </span>
                <span v-if="scope.row.activityType == 8"> 幸运抽奖 </span>
                <span v-if="scope.row.activityType == 13">开卡礼包</span>
                <span v-if="scope.row.activityType == 14">店铺礼包</span>
                <span v-if="scope.row.activityType == 15"
                  >店铺礼包（千人千面）</span
                >
                <span v-if="scope.row.activityType == 63"
                  >BI店铺礼包</span
                >
                <span v-if="scope.row.activityType == 74"
                  >关注礼包</span
                >
                <span v-if="scope.row.activityType == 75"
                  >加购礼包</span
                >
                <span v-if="scope.row.activityType == 16">下单有礼</span>
                <span v-if="scope.row.activityType == 17">首单专享礼</span>
                <span v-if="scope.row.activityType == 18">复购有礼</span>
                <span v-if="scope.row.activityType == 19">下单抽奖</span>
                <span v-if="scope.row.activityType == 20">评价有礼</span>
                <span v-if="scope.row.activityType == 21">裂变神券</span>
                <span v-if="scope.row.activityType == 22">天降红包雨</span>
                <span v-if="scope.row.activityType == 23">欢乐娃娃机</span>
                <span v-if="scope.row.activityType == 24">大家来找茬</span>
                <span v-if="scope.row.activityType == 27">预售有礼</span>
                <span v-if="scope.row.activityType == 28">预售抽奖</span>
                <span v-if="scope.row.activityType == 31">超级裂变券</span>
                <span v-if="scope.row.activityType == 34">加购有礼</span>
                <span v-if="scope.row.activityType == 36">打榜有礼</span>
                <span v-if="scope.row.activityType == 39">生日有礼</span>
                <span v-if="scope.row.activityType == 41">晒单有礼</span>
                <span v-if="scope.row.activityType == 43">N元锁权</span>
                <span v-if="scope.row.activityType == 40">专属赠礼品</span>
                <span v-if="scope.row.activityType == 44">会员升级礼</span>
                <span v-if="scope.row.activityType == 46">满额有礼</span>
                <span v-if="scope.row.activityType == 45">锁权有礼</span>
                <span v-if="scope.row.activityType == 50">情书贺卡</span>
                <span v-if="scope.row.activityType == 47">调查问卷</span>
                <span v-if="scope.row.activityType == 48">定时开奖</span>
                <span v-if="scope.row.activityType == 51">0元试用</span>
                <span v-if="scope.row.activityType == 52">试用回购礼</span>
                <span v-if="scope.row.activityType == 53">购物打卡</span>
                <span v-if="scope.row.activityType == 62">集卡有礼</span>
                <span v-if="scope.row.activityType == 64">组队瓜分奖品</span>
                <span v-if="scope.row.activityType == 65">粉丝打卡</span>
                <span v-if="scope.row.activityType == 66">入会有礼</span>
                <span v-if="scope.row.activityType == 67">销售打榜</span>
                <span v-if="scope.row.activityType == 68">会员成长计划</span>
                <span v-if="scope.row.activityType == 69">拼团砍价</span>
                <span v-if="scope.row.activityType == 71">趣味游戏</span>
                <span v-if="scope.row.activityType == 76">时光许愿池</span>
                <span v-if="scope.row.activityType == 77">购物车锦鲤</span>
                <span v-if="scope.row.activityType == 78">打包一口价</span>
                <span v-if="scope.row.activityType == 79">盖楼有礼</span>
                <span v-if="scope.row.activityType == 80">小红书晒单礼</span>
                <span v-if="scope.row.activityType == 81">集分冲榜</span>
                <span v-if="scope.row.activityType == 82">粉丝集分应援</span>
                <span v-if="scope.row.activityType == 83">晒图pk</span>
                <span v-if="scope.row.activityType == 84">日历打卡</span>
                <span v-if="scope.row.activityType == 85">百变趣答</span>
                <span v-if="scope.row.activityType == 86">AI趣味答题</span>
                <span v-if="scope.row.activityType == 87">答题导购</span>
                <span v-if="scope.row.activityType == 89">积分兑换优惠券</span>
              </template>
            </el-table-column>

            <el-table-column label="活动时间">
              <template slot-scope="scope">
                <div class="activityTime" v-if="currIndex != 5">
                  <span>起: {{ scope.row.startTime }}</span>
                  <span>止: {{ scope.row.endTime }}</span>
                  <span style="color: #2768ff">{{ scope.row.days }}</span>
                </div>
                <div class="activityTime2" v-else>
                  <span>{{
                    scope.row.startTime ? scope.row.startTime : "-"
                  }}</span>
                  <span class="activityTime2_line">至</span>
                  <span>{{ scope.row.endTime ? scope.row.endTime : "-" }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="最后修改时间" prop="updateTime">
            </el-table-column>
            <el-table-column label="活动状态" width="200" v-if="currIndex != 5">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">
                  <span class="yellow-status-icon mr4"></span>
                  未开始
                </span>
                <span v-if="scope.row.status == 2">
                  <span class="blue-status-icon mr4"></span>
                  进行中
                </span>
                <div class="ai-wrap" v-if="scope.row.status == 3">
                  <span>
                    <span class="grey-status-icon mr4"></span>
                    已结束
                  </span>
                  <el-tooltip
                    effect="light"
                    v-if="scope.row.reason && scope.row.status == 3"
                    :content="scope.row.reason"
                    placement="bottom"
                  >
                    <i class="new-icon-box" style="margin: -2px 2px"></i>
                  </el-tooltip>
                  <!-- AI分析 -->
                  <aiToolsBtn :sendData="[{ activityName: scope.row.activityName, activityId: scope.row.id }]" />
                </div>
                <span v-if="scope.row.status == 6">
                  <span class="grey-status-icon mr4"></span>
                  已暂停</span
                >
              </template>
            </el-table-column>
            <el-table-column
              label="参与人数"
              width="120"
              prop="joinNum"
              v-if="currIndex != 5"
            >
              <template slot-scope="scope">
                {{ scope.row.joinNum || 0 }}
              </template>
            </el-table-column>
            <!-- N元锁新增 -->
            <!-- <el-table-column
              v-if="selectArr"
              label="同订单赠品优先级"
              width="150px"
              prop="updateTime"
            >
              <template slot="header">
                <span style="margin-right: 2px">同订单赠品优先级</span>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="开启活动互斥后，同一订单符合多个派样活动条件，将按优先级发放赠品。默认优先级为 1，支持修改。若优先级相同，则按活动创建时间，优先发放最新创建活动的赠品"
                >
                  <span class="new-icon-box"></span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.activityType === 43"
                  @change="onNum(scope.row)"
                  v-model="scope.row.priority"
                  style="width: 110px"
                ></el-input>
                <div style="text-align:center;" v-else>--</div>
              </template>
            </el-table-column> -->
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <div class="editList" v-if="currIndex != 5">
                  <!-- <span
                    v-if="
                      scope.row.status == 1 ||
                      (scope.row.status == 2 &&
                        typeFilter(scope.row.activityType))
                    "
                    @click="
                      modify(
                        scope.row.activityType,
                        scope.row,
                        'edit',
                        scope.row.status
                      )
                    "
                    class="edit fs12"
                  >
                    修改
                  </span>
                  <span v-else style="color: #999" class="edit fs12"> 修改 </span> -->
                  <jd-button 
                    v-if="
                      scope.row.status == 1 ||
                      (scope.row.status == 2 &&
                        typeFilter(scope.row.activityType))
                    "
                    @click="
                      modify(
                        scope.row.activityType,
                        scope.row,
                        'edit',
                        scope.row.status
                      )
                    " type="blueText">修改</jd-button>
                  <jd-button type="blueText" :disabled="true" v-else>修改</jd-button>
                  <!-- <span @click="statisData(scope.row)" class="count fs12"
                    >数据统计</span
                  > -->
                  <jd-button type="blueText" @click="statisData(scope.row)">数据统计</jd-button>
                  <el-dropdown>
                    <jd-button type="blueText" class="new_add_more">更多</jd-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>
                        <span
                          @click="
                            modify(scope.row.activityType, scope.row, 'look')
                          "
                          class="edit menu-item fs12"
                        >
                          <jd-button type="blueText"
                          >查看</jd-button>
                        </span>
                        
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <span
                          @click="
                            modify(scope.row.activityType, scope.row, 'copy')
                          "
                          class="edit menu-item fs12"
                        >
                          <!-- 复制 -->
                            <jd-button type="blueText"
                          >复制</jd-button>
                        </span>
                      </el-dropdown-item>
                      <el-dropdown-item
                        v-if="
                          scope.row.status == 2 && scope.row.activityType == 8
                        "
                      >
                        <span
                          @click="handlerActive(scope.row)"
                          class="edit menu-item fs12"
                        >
                          <!-- 暂停 -->
                            <jd-button type="blueText"
                          >暂停</jd-button>
                        </span>
                      </el-dropdown-item>
                      <el-dropdown-item v-if="scope.row.status == 6">
                        <span
                          @click="handlerActive(scope.row)"
                          class="edit menu-item fs12"
                        >
                          <!-- 启动 -->
                            <jd-button type="blueText"
                          >启动</jd-button>
                        </span>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <span
                          v-if="scope.row.status == 2"
                          @click="endenActivity(scope.row.id)"
                          class="end menu-item fs12"
                          >
                          <!-- 结束 -->
                            <jd-button type="blueText"
                          >结束</jd-button>
                          </span
                        >
                        <span v-else style="color: #999" class="edit menu-item fs12">
                          结束
                        </span>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <span
                          @click="deleteActivity(scope.row)"
                          class="delete menu-item fs12"
                          >
                          <!-- 删除 -->
                            <jd-button type="blueText"
                          >删除</jd-button>
                          </span
                        >
                      </el-dropdown-item>
                      <!-- 打榜有礼 添加黑名单 -->
                      <el-dropdown-item v-if="scope.row.activityType == 36">
                        <span
                          @click="balck(scope.row)"
                          class="delete menu-item fs12"
                          v-if="scope.row.status != 3 && !scope.row.isPastShowRankTime"
                          >
                          <!-- 黑名单 -->
                           <jd-button type="blueText"
                          >黑名单</jd-button>
                          </span
                        >
                        <!-- 活动结束或者过了开榜时间之后 -->
                        <span v-else style="color: #999" class="edit menu-item fs12">
                          黑名单
                        </span>
                      </el-dropdown-item>
                      <!-- 下单抽奖添加白名单 -->
                      <el-dropdown-item v-if="scope.row.activityType == 19">
                        <span class="menu-item fs12" @click="addWhiteList(scope.row)"
                          >
                          <!-- 白名单 -->
                            <jd-button type="blueText"
                          >白名单</jd-button>
                          </span
                        >
                      </el-dropdown-item>
                      <!-- 晒单有礼新增库存提示按钮 -->
                      <el-dropdown-item v-if="scope.row.activityType == 41&&scope.row.status != 3">
                        <span class="menu-item fs12" @click="addInventoryTip(scope.row)"
                          >
                           <jd-button type="blueText"
                          >库存提示</jd-button>
                          </span
                        >
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div v-else>
                  <jd-button
                    type="blueText"
                    style="margin-right: 8px"
                    @click="editDraft(scope.row)"
                    >编辑</jd-button
                  >
                  <jd-button type="blueText" @click="delDraft(scope.row)"
                    >删除</jd-button
                  >
                </div>
              </template>
            </el-table-column>
          </jd-table>
        </template>
      </div>
    <!-- </div> -->

    <!-- 创建活动步骤 -->
    <points-task-activity
      ref="createSte"
      class="marginClass"
      v-if="createStep == 2"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :createStep="createStep"
      :isSave="isSave"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
    ></points-task-activity>

    <!-- 创建活动步骤 -->
    <create-activity-step
      v-if="createStep == 4"
      class="marginClass"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityDataTwo"
      :stepNum="stepNum"
      :ids="ids"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      :isSave="isSave"
    ></create-activity-step>
    <!-- 下单抽奖 -->
    <create-activity-step2
      v-if="createStep == 19"
      class="marginClass"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityDataTwo"
      :stepNum="stepNum"
      :isSave="isSave"
      :backgroundOpacity="backgroundOpacity"
      :ids="ids"
      :isDraftEdit="isDraftEdit"
    ></create-activity-step2>

    <!-- 电铺礼包千人千面 -->
    <create-task-electric
      class="marginClass"
      v-if="createStep == 15"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :createStep="createStep"
      :isSave="isSave"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
    ></create-task-electric>

    <!-- 首购  下单  复购 -->
    <create-task-polite
      class="marginClass"
      v-if="createStep == 16"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :createStep="createStep"
      :isSave="isSave"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
    ></create-task-polite>
    <!-- 裂变  评价  红包雨 -->
    <create-task-evaluation
      class="marginClass"
      v-if="createStep == 20"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :createStep="createStep"
      :isSave="isSave"
      :backgroundOpacity="backgroundOpacity"
      :statusComment="statusComment"
      :isDraftEdit="isDraftEdit"
    ></create-task-evaluation>
    <!-- 数据统计-N元锁权 -->
    <statistics2
      class="marginClass"
      style="background-color: #fff"
      v-if="createStep === 433"
      @returnStep="returnStep"
      @triggerVersion="triggerVersion"
      :rowData="rowData"
      :ids1="ids1"
    ></statistics2>
    <!-- 数据统计-旧版 -->
    <statistics
      class="marginClass"
      style="background-color: #fff"
      v-if="createStep == 3 && !isNew"
      @returnStep="returnStep"
      @triggerVersion="triggerVersion"
      :rowData="rowData"
      :ids1="ids1"
    ></statistics>
    <!-- 数据统计-新版 -->
    <statistics-new
      class="marginClass"
      style="background-color: #fff"
      v-if="createStep == 3 && isNew"
      @returnStep="returnStep"
      @triggerVersion="triggerVersion"
      :rowData="rowData"
      :ids1="ids1"
    ></statistics-new>
    <!-- v3.4邀请开卡有礼 -->
    <create-invite-step
      class="marginClass"
      ref="createSte"
      v-if="createStep == 5"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :createStep="createStep"
      :isSave="isSave"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
    ></create-invite-step>
    <!-- 游戏 -->
    <points-task-games
      class="marginClass"
      v-if="createStep == 23"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :createStep="createStep"
      :isSave="isSave"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
    ></points-task-games>

    <!-- 预售 -->
    <create-task-book
      class="marginClass"
      v-if="createStep == 27"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :createStep="createStep"
      :isSave="isSave"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
    ></create-task-book>
    <!-- 超级裂变 -->
    <create-task-superFission
      class="marginClass"
      v-if="createStep == 31"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :createStep="createStep"
      :isSave="isSave"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
    ></create-task-superFission>

    <!-- 打榜有礼 -->
    <create-Activity-Order
      ref="createStep36"
      v-if="createStep == 36"
      :stepNum="stepNum"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      class="marginClass"
    ></create-Activity-Order>

    <!-- 生日有礼 -->
    <create-brithday
      class="marginClass"
      v-if="createStep == 39"
      ref="createStep39"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :ids="valueRow.id ? valueRow.id : ''"
      :activeValue="activeValue"
      :activityData="activityData"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></create-brithday>

    <!-- 会员升级礼 -->
    <memberUpgradePage
      class="marginClass"
      v-if="createStep == 44"
      ref="createStep44"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :ids="valueRow.id ? valueRow.id : ''"
      :activeValue="activeValue"
      :activityData="activityData"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></memberUpgradePage>

    <!-- 情书贺卡 -->
    <billetDouxGreetingCard
      class="marginClass"
      v-if="createStep == 50"
      ref="createStep50"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :ids="valueRow.id ? valueRow.id : ''"
      :activeValue="activeValue"
      :activityData="activityData"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></billetDouxGreetingCard>

    <!-- 晒单有礼 -->
    <create-singles-politely
      class="marginClass"
      v-if="createStep == 41"
      ref="createStep41"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :ids="valueRow.id ? valueRow.id : ''"
      :activeValue="activeValue"
      :activityData="activityData"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></create-singles-politely>

    <fullAmountWithGifts
      v-if="createStep == 46"
      ref="createStep46"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :stepNum="stepNum"
      :backgroundOpacity="backgroundOpacity"
      :activityData="activityData"
      :activeValue="activeValue"
      :valueRow="valueRow"
      :ids="valueRow.id ? valueRow.id : ''"
      :isDraftEdit="isDraftEdit"
    >
    </fullAmountWithGifts>

    <memberdataanalysis
      v-if="createStep == 12"
      :pageName="'数据统计'"
      @returnBack="returnBackChange"
      :ids="ids"
    ></memberdataanalysis>
    <dataAnalysis
      v-if="createStep == 11"
      :pageName="'数据统计'"
      @returnBack="returnBackChange"
      :ids="ids"
    ></dataAnalysis>
    <!-- 中奖查询 -->
    <winSearch
      v-if="createStep == 500"
      @returnBack="returnBackChange"
    ></winSearch>
    <!-- N元锁权 -->
    <create-shop-Re-Buy
      v-if="createStep == 43"
      ref="createStep4"
      :activityData="activityData"
      :activeValue="activeValue"
      :valueRow="valueRow"
      :isLook="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></create-shop-Re-Buy>
    <!-- 积分锁权45 -->
    <create-activity-lock-auth
      ref="createStep45"
      v-if="createStep == 45"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></create-activity-lock-auth>
    <!-- 问卷调查47 -->
    <create-questionnaire
      ref="createStep47"
      v-if="createStep == 47"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></create-questionnaire>
    <!-- 定时开奖48 -->
    <create-timed-lottery-draw
      ref="createStep48"
      v-if="createStep == 48"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></create-timed-lottery-draw>
    <!-- 试用复购礼 -->
    <trialGift
      ref="createStep52"
      v-if="createStep == 52"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      ></trialGift>
    <!-- 0元试用51 -->
    <create-zero-trial
      ref="createStep51"
      v-if="createStep == 51"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></create-zero-trial>
    <!-- 购物打卡53 -->
    <create-shop-check-in
      ref="createStep53"
      v-if="createStep == 53"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></create-shop-check-in>
    <!-- 集卡有礼 -->
    <create-card-collect
      ref="createStep62"
      v-if="createStep == 62"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></create-card-collect>
    <!-- 组队瓜分奖品 -->
    <teamSharePrizes
      ref="createStep64"
      v-if="createStep == 64"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      ></teamSharePrizes>
    <!-- 粉丝打卡 -->
    <fansCheckIn
      ref="createStep65"
      v-if="createStep == 65"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></fansCheckIn>
    <!-- 入会有礼 -->
    <joinGift
      ref="createStep66"
      v-if="createStep == 66"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></joinGift>
    <!-- BI店铺礼包 -->
    <createBIStoreGift
      class="marginClass"
      v-if="createStep == 63"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :stepNum="stepNum"
      :valueRow="valueRow"
      :activeValue="activeValue"
      :createStep="createStep"
      :isSave="isSave"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
    ></createBIStoreGift>
    <salesRanking
      ref="createStep68"
      v-if="createStep == 67"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></salesRanking>

    <userLifecycle
      ref="createStep68"
      v-if="createStep == 68"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></userLifecycle>
     <!-- 拼团砍价 -->
    <groupBuying
      ref="createStep69"
      v-if="createStep == 69"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></groupBuying>

    <!-- 趣味游戏 -->
    <createFunGame
      ref="createStep71"
      v-if="createStep == 71"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></createFunGame>

     <!-- 关注礼包和加购礼包 -->
    <createFollowGift
      ref="createStep74"
      v-if="createStep == 74 || createStep == 75"
    ></createFollowGift>

    <!-- 时光许愿池 -->
    <createTimeWishingPool
      ref="createStep76"
      v-if="createStep == 76"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></createTimeWishingPool>
    <!-- 购物车锦鲤 -->
    <createShoppingCartKoi
      ref="createStep77"
      v-if="createStep == 77"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></createShoppingCartKoi>

    <!-- 打包一口价 -->
    <createFixedPricePack
      ref="createStep78"
      v-if="createStep == 78"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></createFixedPricePack>

    <!-- 盖楼有礼 -->
    <createBuildingCourtesy
      ref="createStep79"
      v-if="createStep == 79"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></createBuildingCourtesy>

    <!-- 小红书晒单礼 -->
    <createXhsSunGift
      ref="createStep80"
      v-if="createStep == 80"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></createXhsSunGift>

     <!-- 集分冲榜 -->
    <createCollectPointRank
      ref="createStep81"
      v-if="createStep == 81"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></createCollectPointRank>
    <!-- 晒图pk -->
    <photoContest
      ref="createStep83"
      v-if="createStep == 83"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></photoContest>

     <!-- 粉丝集分应援 -->
     <createFanPointSupport
      ref="createStep82"
      v-if="createStep == 82"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></createFanPointSupport>
    
     <!-- 日历打卡 -->
     <createCalendarCheckIn
      ref="createStep84"
      v-if="createStep == 84"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></createCalendarCheckIn>

    <!-- 百变趣答 -->
    <createFunAnswer
      ref="createStep85"
      v-if="createStep == 85"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></createFunAnswer>
    <!-- 百变趣答 -->
    <answeringShopping
      ref="createStep87"
      v-if="createStep == 87"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></answeringShopping>


    <!-- 积分兑换优惠券 -->
    <pointsRedemptionCoupon
      ref="createStep89"
      v-if="createStep == 89"
      :stepNum="stepNum"
      :activityData="activityData"
      :valueRow="valueRow"
      :backgroundOpacity="backgroundOpacity"
      :isDraftEdit="isDraftEdit"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></pointsRedemptionCoupon>

    <!-- 结束活动弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="outerVisible"
      width="400px"
      :before-close="closehandleDelete"
    >
      <div style="display: flex; align-items: center">
        <img
          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tip_red.png"
          style="width: 14px; height: 14px"
        />
        <span style="font-size: 14px; margin-left: 3px">是否结束活动？</span>
      </div>
      <div slot="footer">
        <jd-button @click="closehandleDelete">取 消</jd-button>
        <jd-button
          type="blue"
          style="margin-left: 8px"
          @click="handleDeleteTable"
          >确 定</jd-button
        >
      </div>
    </el-dialog>

    <!-- 删除活动弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="outerVisibleTwo"
      width="400px"
      :before-close="closehandleDeleteTwo"
    >
      <div style="display: flex; align-items: center">
        <img
          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tip_red.png"
          style="width: 14px; height: 14px"
        />
        <span style="font-size: 14px; margin-left: 3px">是否删除活动？</span>
      </div>
      <div slot="footer" class="buttonBox">
        <jd-button @click="closehandleDeleteTwo">取 消</jd-button>
        <jd-button
          type="blue"
          style="margin-left: 8px"
          @click="handleDeleteTableTwo"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
    <!-- 暂停活动弹框 -->
    <el-dialog title="提示" :visible.sync="showPauseActive" width="400px">
      <div style="display: flex; align-items: center">
        <img
          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tip_red.png"
          style="width: 14px; height: 14px"
        />
        <span style="font-size: 14px; margin-left: 3px"
          >是否{{ activeRow.status == 6 ? "启动" : "暂停" }}活动？</span
        >
      </div>
      <div slot="footer" class="buttonBox">
        <jd-button @click="showPauseActive = false">取 消</jd-button>
        <jd-button type="blue" style="margin-left: 8px" @click="pauseActive"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
    <!-- 黑名单弹窗 -->
    <el-dialog title="黑名单" :visible.sync="showBlacklist" width="800px">
      <jd-tip style="margin-bottom: 16px; font-size: 14px; color: #666;">
        黑名单针对用户&订单号进行屏蔽，登记黑名单后，用户依旧可参与活动，仅对指定用户&指定订单不记录进入榜单数据，添加后可能造成客诉请谨慎配置与说明
      </jd-tip>
      <div style="margin-bottom: 16px;">
        <jd-button type="blue" @click="showAddBlacklistAdd">新增黑名单</jd-button>
      </div>
      <jd-table 
           :loading="tableLoding"
           :tableData="blacklistData" 
            style="width: 100%"
            :pageInfo="{
              pageNum: current,
              pageSize: size,
              noShow: false,
              total: totalRecord,
          }"
          @handlePage="handleBlacklistPages"
            >
        <el-table-column prop="customerPin" label="用户PIN" />
       <el-table-column prop="orderIds" label="订单号">
           <template slot-scope="scope">
                <div>
                    {{ scope.row.dataType==0?'全部订单':scope.row.dataType == 1?scope.row.orderIds:'' }}
                </div>
           </template>
          </el-table-column>
        <el-table-column prop="updateTime" label="最后修改时间" />
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <jd-button @click="editBlack(scope.row)" type="blueText">编辑</jd-button>
            <jd-button  @click="delBlack(scope.row)"  type="blueText" >删除</jd-button>
          </template>
        </el-table-column>
      </jd-table>
      <div slot="footer" class="buttonBox">
        <jd-button @click="showBlacklist = false">取消</jd-button>
        <jd-button type="blue" style="margin-left: 8px" @click="saveBlacklist">保存</jd-button>
      </div>
    </el-dialog>
    
    <!-- 新增黑名单弹窗 -->
    <el-dialog :title="blackTitle" :visible.sync="showAddBlacklist" width="500px">
      <div style="margin-bottom: 20px;">
        <div style="margin-bottom: 10px;">
          <label style="font-size: 14px;">用户PIN：</label>
          <el-input 
            v-model="newBlacklistForm.customerPin" 
            placeholder="请输入京东账号名" 
            style="width: 300px;"
          />
        </div>
        <div style="margin-bottom: 10px; display: flex; align-items: center;">
          <label style="font-size: 14px; margin-right: 10px; white-space: nowrap;">订单号：</label>
          <el-radio 
            v-model="newBlacklistForm.dataType" 
            :label="0"
            @change="handleOrderTypeChange"
            style="margin-right: 20px;"
          >全部订单</el-radio>
          <el-radio 
            v-model="newBlacklistForm.dataType" 
            :label="1"
            @change="handleOrderTypeChange"
            style="margin-right: 10px;"
          >指定订单</el-radio>
          <el-input 
            v-model="newBlacklistForm.orderIds" 
            placeholder="多个之间用英文逗号隔开" 
            style="width: 180px;"
            v-if="newBlacklistForm.dataType === 1"
          />
        </div>
        <div style="margin-top: 20px; padding: 10px; background-color: #f5f7fa; border-left: 4px solid #e6a23c; font-size: 12px; color: #606266;">
          <div style="margin-bottom: 5px;">1. 用户PIN与订单号下的用户PIN一致，否则无法保存；</div>
          <div style="margin-bottom: 5px;">2. 建议活动前保存，保存完成后不要修改否则数据会根据配置变更；</div>
          <div>3. 开榜后，榜单数据锁定，加入黑名单无法屏蔽；</div>
        </div>
      </div>
      <div slot="footer" class="buttonBox">
        <jd-button @click="showAddBlacklist = false">取消</jd-button>
        <jd-button type="blue" style="margin-left: 8px" @click="saveAddBlacklist">保存</jd-button>
      </div>
    </el-dialog>

    <!-- 活动配置弹窗 -->
    <jd-dialog
      title="活动配置"
      :visible.sync="isShowActivityConfig"
      width="500px"
      :before-close="beforeConfigclose"
    >
      <div
        style="display: flex; flex-direction: column; line-height: 16px"
        v-loading="configLoading"
      >
        <div style="margin-bottom: 20px">勾选如下配置后保存表示对应规则：</div>
        <div style="margin-left: 10px">
          <el-checkbox
            v-model="activityConfig.checkExistOrder"
            :true-label="1"
            :false-label="0"
          ></el-checkbox>
          <span style="margin-left: 10px; line-height: 24px;"
            >同类型活动下，同个订单只能被解锁成功1次（生效活动：首购有礼、复购有礼、下单有礼、下单抽奖、预售有礼、预售抽奖、会员成长计划）</span
          >
          <el-popover
            placement="top-start"
            width="400"
            offset="100"
            trigger="hover"
            content="该配置仅在单类型的活动生效，不跨类型活动；比如：下单有礼有3个活动，则一个订单在其中一个活动解锁成功后不能在其它两个活动解锁；"
          >
            <span style="" slot="reference">
              <i class="new-icon-box" style="margin: -2px 2px;"></i>
            </span>
          </el-popover>
        </div>
      </div>
      <div slot="footer">
        <jd-button @click="isShowActivityConfig = false">取 消</jd-button>
        <jd-button
          type="blue"
          style="margin-left: 8px"
          @click="handleConfirmConfig"
          >保 存</jd-button
        >
      </div>
    </jd-dialog>
    <!-- 白名单弹窗 -->
    <white-list
      v-if="showWhiteList"
      v-model="showWhiteList"
      :whiteRow="whiteRow"
    />
    <!-- 添加渠道链接弹窗 -->
    <jd-dialog
      title="添加渠道链接"
      :visible.sync="addChannelVisible"
      append-to-body
      width="400px"
      @comfirm="handleChannelSave"
      @close="addChannelVisible = false"
      :sureLoading="addChannelLoading"
    >
      <el-form class="new-input-box">
        <el-form-item label="渠道名称: " required>
          <el-input v-model="channelName" maxLength="15" placeholder="请输入渠道名称" class="w260"/>
        </el-form-item>
      </el-form>
    </jd-dialog>
    <!-- 二维码弹窗 -->
    <show-image 
      :visible.sync="qrcodeDialogVisible"
      :qrcode-data="qrcodePreviewData">
    </show-image>

    <!-- 库存提示弹窗 -->
    <inventoryTipDialog
      v-if="isShowInventory"
      :visible.sync="isShowInventory"
      :activityInfo="activityInfo"
      @close="getPrizeStockWarning"
    />
    <!-- 我的AI资源弹窗 -->
    <aIResource
      v-if="isShowAIResource"
      :isShow.sync="isShowAIResource"
    />
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import inputForm from "@/components/jhk/inputForm";
import aiToolsBtn from "@/components/ai/aiToolsBtn.vue";
import fullAmountWithGifts from "../activity/full_amount_with_gifts.vue";
import pointsTaskActivity from "../activity/points_task_activity.vue";
import createInviteStep from "../activity/points_task_Invite.vue";
import createActivityStep from "../activity/create_activity_step.vue";
import createActivityStep2 from "../activity/create_activity_step2.vue";
import statistics from "../activity/activity_data_statistics.vue";
import statistics2 from "../activity/activity_data_statistics2.vue";
import statisticsNew from "../activity/activity_data_statistics_new.vue";
import createTaskElectric from "../activity/points_task_electric.vue";
import createTaskPolite from "../activity/points_task_polite.vue";
import createTaskEvaluation from "../activity/points_task_evaluation.vue";
import pointsTaskGames from "../activity/points_task_games.vue";
import createTaskBook from "../activity/points_task_book.vue";
import createActivityOrder from "../activity/create_activity_order.vue";
import giftList from "../activity/gift_list.vue";
import memberdataanalysis from "../activity/memberCenter/member-data-analysis.vue";
import member from "../activity/memberCenter/member.vue";
import dataAnalysis from "../activity/memberCenter/data-analysis.vue";
import qrcodeVue from "qrcode-vue";
import createTaskSuperFission from "../activity/points_task_superFission.vue";
import createBrithday from "../activity/create-brithday";
import whiteList from "./components/whiteList.vue";
import createSinglesPolitely from "../activity/create_singles_politely.vue";
import createShopReBuy from "../activity/create_shopReBuy.vue";
import createActivityLockAuth from "../activity/create_activity_lockAuth.vue";
import createTimedLotteryDraw from "../activity/create_timed_lottery_draw.vue";
import winSearch from "../activity/winSearch.vue";
import memberUpgradePage from "@/views/interactiveMarketing/activity/member-upgrade_page.vue";
import billetDouxGreetingCard from "@/views/interactiveMarketing/activity/billet-doux-greeting-card.vue";
import createQuestionnaire from "../activity/create_questionnaire.vue";
import createZeroTrial from "../activity/create-zero-trial.vue";
import ShowImage from './components/showImage.vue'
import createCardCollect from "../activity/create-card-collect.vue";
import fansCheckIn from "../activity/fansCheckIn.vue";
import teamSharePrizes from "../activity/teamSharePrizes.vue";
import createBIStoreGift from "../activity/create-bi-store-gift.vue";
import joinGift from "../activity/joinGift.vue";
import salesRanking from "../activity/salesRanking.vue";
import userLifecycle from "../activity/userLifecycle.vue";
import inventoryTipDialog from "./components/inventoryTipDialog.vue";
import groupBuying from "../activity/groupBuying.vue";
import createFunGame from "../activity/create-fun-game.vue";
import createFollowGift from "../activity/create-bi-follow-gift.vue";
import createTimeWishingPool from "../activity/create-time-wishing-pool.vue";
import createShoppingCartKoi from "../activity/create-shopping-cart-koi.vue";
import createFixedPricePack from "../activity/create-fixed-price-pack.vue";
import createBuildingCourtesy from "../activity/create-building-courtesy.vue";
import createXhsSunGift from "../activity/xhsSunGift/index.vue";
import createCollectPointRank from "../activity/create-collect-point-rank.vue";
import createFanPointSupport from "../activity/create-fan-point-support.vue";
import createCalendarCheckIn from "../activity/create-calendar-checkIn.vue";
import createFunAnswer from "../activity/create-fun-answer.vue";
import answeringShopping from "../activity/answering_shopping.vue";
import pointsRedemptionCoupon from "../activity/pointsRedemptionCoupon.vue";

import photoContest from "../activity/photoContest.vue";

import aIResource from "./components/aIResource.vue";
import { getShortLink } from "@/api/jhk/marketing/shortLink";
import {
  queryActivity,
  endEvent,
  deleteEvent,
  getActivitySetting,
  saveActivitySetting,
  customSellerLinkPage,
  customSellerLinkSave,
  prizeStockWarningText,
  updateShopNameType
} from "@/api/jhk/activityController";
import createShopCheckIn from "../activity/create_shop_check_in.vue";
import trialGift from "../activity/trial_repurchase_gift.vue";
import {
  prefixurl,
  giftBagEide,
  thousandGiftDetail,
  activityDetail,
  getBlacklist,
  addBlacklist,
  deleteBlacklist
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import { activityUpdate } from "@/api/jhk/integralCenter/integralTask.js";
import { paradise } from "@/api/jhk/integralCenter/PointActivityAnalyticController";
import { useActivityTypeList } from "@/common/hook";
export default {
  components: {
    memberdataanalysis,
    dataAnalysis,
    aiToolsBtn,
    member,
    giftList,
    qrcodeVue,
    createTaskBook,
    inputForm,
    pointsTaskActivity,
    createActivityStep,
    createActivityStep2,
    createInviteStep,
    createActivityOrder,
    statistics,
    statisticsNew,
    createTaskElectric,
    createTaskPolite,
    createTaskEvaluation,
    pointsTaskGames,
    memberdataanalysis,
    createTaskSuperFission,
    createBrithday,
    createActivityLockAuth,
    createTimedLotteryDraw,
    whiteList,
    createSinglesPolitely,
    createShopReBuy,
    statistics2,
    winSearch,
    memberUpgradePage,
    fullAmountWithGifts,
    billetDouxGreetingCard,
    createQuestionnaire,
    createZeroTrial,
    createShopCheckIn,
    trialGift,
    ShowImage,
    createCardCollect,
    fansCheckIn,
    teamSharePrizes,
    createBIStoreGift,
    joinGift,
    salesRanking,
    userLifecycle,
    inventoryTipDialog,
    groupBuying,
    createFunGame,
    createFollowGift,
    createTimeWishingPool,
    createShoppingCartKoi,
    createFixedPricePack,
    createBuildingCourtesy,
    createXhsSunGift,
    aIResource,
    createCollectPointRank,
    createFanPointSupport,
    photoContest,
    createCalendarCheckIn,
    createFunAnswer,
    answeringShopping,
    pointsRedemptionCoupon,
  },
  created() {
    if(this.$route.params.isDataStatistics == true && this.$store.state.dataStatistics){
      this.statisData(this.$store.state.dataStatistics);
      this.$store.state.dataStatistics = null;
    }
  },
  props: {
    mainTypes: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      isShowAIResource: false,
      shopNameType: 0,
      isStart:false,
      inventorytip: "",
      activityInfo: {},
      isShowInventory: false,
      tableLoding: true,
      current: 1,
      size: 10,
      totalRecord: 0,
      blackLogo:true,
      blackTitle: '新增黑名单',
      tableLodingCurrIndexOne: true,
      tableLodingCurrIndexTwo: true,
      actLinkIds:'',
      xcxUrl: '',
      tableDatas: [
      ],
      tableDatas2: [
      ],
      showPauseActive: false,
      activeRow: {},
      // 黑名单弹窗
      showBlacklist: false,
      blacklistData: [], // 黑名单列表数据
      // 新增黑名单弹窗
      showAddBlacklist: false,
      newBlacklistForm: {
        customerPin: '', // 用户PIN
        orderIds: '', // 订单号
        dataType: 0 // 0: 全部订单, 1: 指定订单
      },
      actItemInfo: true,
      activityPlusMainTypes: 1,
      form: {
        activityName: "",
        activityType: "",
        status: "",
        startTime: "",
        endTime: "",
        startUpdateTime: "",
        endUpdateTime: "",
        createByMe: false,
      },
      selectArr: [],
      qrcodeVue: {
        size: 200,
        bgColor: "#fff",
        fgColor: "#000",
        value: "https://www.baidu.com/", //二维码地址
        logo: require("@/assets/new-images/jd_logo.svg"), //logo图片
      },
      backgroundOpacity: false,
      isDraftEdit: false,
      statusComment: false,
      isSave: true,
      pageName: "忠诚度管理-积分-活动管理",
      talbeLoading: false,
      qrcode: null,
      outerVisible: false,
      outerVisibleTwo: false,
      valueRow: {},
      createVal: 0,
      activityDataTwo: {
        telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/night_m.png",
        telCode: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/code.png",
        id: 1,
        name: "幸运抽奖",
      },
      activityData: {},
      createStep: 1,
      activityList: [],
      // 头部表单配置项
      inputData: [
        {
          name: "活动名称:",
          val: "activityType",
          placeholder: "请选择或输入",
          selectArr: [
            { label: "签到赢好礼", value: 1 },
            { label: "每日抢好礼", value: 3 },
            { label: "关注店铺有礼", value: 4 },
            { label: "邀请开卡有礼", value: 5 },
            { label: "邀请关注有礼", value: 6 },
            { label: "完善信息有礼", value: 7 },
            { label: "开卡礼包", value: 13 },
            { label: "店铺礼包", value: 14 },
            { label: "店铺礼包（千人千面）", value: 15 },
            { label: "下单有礼", value: 16 },
            { label: "首单专享礼", value: 17 },
            { label: "复购有礼", value: 18 },
            { label: "下单抽奖", value: 19 },
            { label: "评价有礼", value: 20 },
            { label: "裂变神券", value: 21 },
            { label: "天降红包雨", value: 22 },
            { label: "预售有礼", value: 27 },
            { label: "预售抽奖", value: 28 },
          ],
        },
        {
          name: "活动时间:",
          myDate: true,
          noInitValue: true, // 不用给初始化值
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "活动状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
        {
          name: "最后修改时间:",
          myDate: true,
          val: ["startUpdateTime", "endUpdateTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          // isdefault:true,
        },
      ],
      inputData2: [
        {
          name: "活动名称:",
          val: "activityName",
          placeholder: "请输入活动名称",
        },

        {
          name: "活动时间:",
          noInitValue: true,
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
        {
          name: "活动状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
        {
          name: "最后修改时间:",
          myDate: true,
          val: ["startUpdateTime", "endUpdateTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          // isdefault:true,
        },
      ],
      currentPage: 1,
      totalNum: 0,
      recordData: {
        size: 10,
        current: 1,
      },
      rowData: {},
      ids: "",
      ids1: "",
      activityUrl: "",
      venderId: "",
      aaa: "",
      status: 1,
      mytimestart: "",
      mytimeend: "",
      opentime: true,
      tabSwitchList: ["全部", "进行中", "未开始", "已结束"],
      tabSwitchListData: [
        { value: 0, label: "全部" },
        { value: 1, label: "进行中" },
        { value: 2, label: "未开始" },
        { value: 6, label: "已暂停" },
        { value: 3, label: "已结束" },
        { value: 5, label: "草稿箱" },
      ],
      tabSwitchListDatas: [
        { value: 0, label: "默认链接" },
        { value: 1, label: "店铺渠道链接" },
        { value: 2, label: "自定义渠道链接" },
      ],
      currIndex: 0,
      currIndexs: 0,
      isStart: false,
      isCopy: false,
      isShowActivityConfig: false, // 显示活动配置弹窗
      activityConfig: {
        checkExistOrder: 0,
        id: "",
        activityType: 0,
      },
      configLoading: false,
      showWhiteList: false,
      whiteRow: {},
      isNew: false, // 是否新版本
      searchFormInfo: [
        {
          label: "活动名称：",
          prop: "activityName",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "活动类型：",
          slot: "activityType",
        },
        {
          label: "活动时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startTime: "",
          endTime: ""
        },
        {
          label: "最后修改时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startUpdateTime",
          endKey: "endUpdateTime",
        },
      ],
      addChannelVisible: false, // 添加渠道链接弹窗
      addChanneltype: 0, // 添加渠道链接的活动类型
      channelName: "", // 新增渠道名称
      addChannelLoading: false, // 新增渠道loading
      tableChannelInfo: [ // 店铺渠道链接表格配置
        {
          prop: 'sellerLinkName',
          label: '渠道名称',
          width: 280
        },
        {
          prop: 'linkUrl',
          label: '链接地址',
          slot: 'linkUrls',
          width: 280
        },
        {
          prop: 'qrCode',
          label: '二维码',
          slot: 'qrCode',
          width: 220
        },
        {
          prop: 'action',
          label: '操作',
          slot: 'action',
          width: 180,
        },
      ],
      tableSelfInfo: [ // 自定义渠道链接表格配置
        {
          prop: 'shopName',
          label: '渠道名称',
          slot: 'shopName',
          width: 280
        },
        {
          prop: 'linkUrl',
          label: '链接地址',
          slot: 'linkUrl',
          width: 280
        },
        {
          prop: 'qrCode',
          label: '二维码',
          slot: 'qrCode',
          width: 220
        },
        {
          prop: 'createTime',
          label: '创建时间',
          width: 220,
        },
        {
          prop: 'action',
          label: '操作',
          slot: 'action',
          width: 180,
        },
      ],
      showMask: null,
      qrcodeDialogVisible: false, // 控制二维码弹窗显示
      qrcodePreviewData: null, // 二维码数据
    };
  },
  computed: {
    getLinkUrl() {
      return (row) => {
        // 二维码进小程序
        let xcxUrl = this.$commonUrl();
        this.xcxUrl = this.$commonUrl();
        let options = {
          activityId: row.activityId,
          venderId: row.venderId,
          activityType: row.subType,
          id: row.activityId,
          index: 222,
          sellerLinkId: row.id
        };
        let params1 = `%7B%22activityId%22%3A%22${options.activityId}%22%2C%22venderId%22%3A%22${options.venderId}%22%2C%22activityType%22%3A${options.activityType}%2C%22id%22%3A${options.id}%2C%22index%22%3A${options.index}%2C%22sellerLinkId%22%3A${options.sellerLinkId}%7D`;
        let pcParams = encodeURIComponent(
          Object.keys(options)
            .map((item) => `${item}=${options[item]}`)
            .join("&")
        );
        // 19：特定活动类型
        if (row.subType == 19) {
          return xcxUrl +
             `pages/interactPark/placeOrder/placeOrder.html%3F${pcParams}`
        } 
        // 46：购买礼品类型
        else if (row.subType == 46) {
          return xcxUrl +
            `pages/interactTask/purchaseGifts/purchaseGifts.html%3F${pcParams}`
        }

        // 1：签到赢好礼
        else if (row.subType == 1) {
          return xcxUrl +
            `pages/interactTask/signPolite/signPolite.html%3F${pcParams}`
        }
        // 2：浏览礼品有礼
        // else if (row.subType == 2) {
        //   return ""
        // }
        // 3：每日抢好礼
        else if (row.subType == 3) {
          return xcxUrl +
            `pages/interactTask/robGoodPresent/robGoodPresent.html%3F${pcParams}`;
        }
        // 4：关注店铺有礼
        else if (row.subType == 4) {
          return xcxUrl +
            `pages/interactTask/attentionShop/attentionShop.html%3F${pcParams}`;
        }
        // 5：邀请开卡有礼
        else if (row.subType == 5) {
          // 同时设置pcUrl
          row.pcUrl = `${xcxUrl}pages/interactTask/inviteCard/inviteCard.html%3F${pcParams}`;
          return xcxUrl +
            `pages/interactTask/inviteCard/inviteCard.html%3F${pcParams}`;
        }
        // 6：邀请关注店铺
        else if (row.subType == 6) {
          return xcxUrl +
            `pages/interactTask/invite/invite.html%3F${pcParams}`;
        }
        // 7：完善信息有礼
        else if (row.subType == 7) {
          return xcxUrl +
            `pages/interactTask/perfect_information/perfect_information.html%3F${pcParams}`;
        }
        // 8：幸运抽奖
        else if (row.subType == 8) {
          return xcxUrl +
            `pages/interactPark/bigTurntable/bigTurntable.html%3F${pcParams}`
        }
        // 京获客1.2 下单复购首购
        else if (
          row.subType == 16 ||
          row.subType == 17 ||
          row.subType == 18
        ) {
          // 同时设置pcUrl
          row.pcUrl = `${xcxUrl}pages/interactTask/ordergift/ordergift.html%3F${pcParams}`;
          return xcxUrl +
            `pages/interactTask/ordergift/ordergift.html%3F${pcParams}`;
        }
        // 19：下单抽奖
        else if (row.subType == 19) {
          return xcxUrl +
            `pages/interactPark/placeOrder/placeOrder.html%3F${pcParams}`;
        }
        // 京获客1.3 评价有礼
        else if (row.subType == 20) {
          return xcxUrl +
            `pages/interactTask/evaluation_gift/evaluation_gift.html%3F${pcParams}`;
        }
        // 京获客1.3 裂变神券
        else if (row.subType == 21) {
          return xcxUrl +
            `pages/interactTask/groupCoupon/groupCoupon.html%3F${pcParams}`;
        }
        // 京获客1.3 红包雨
        else if (row.subType == 22) {
          return xcxUrl +
            `pages/interactTask/redPacketRain/redPacketRain.html%3F${pcParams}`;
        }
        // 京获客1.4 欢乐娃娃机
        else if (row.subType == 23) {
          return xcxUrl +
            `pages/gameCore/catchDoll/catchDoll.html%3F${pcParams}`;
        }
        // 京获客1.4 大家来找茬
        else if (row.subType == 24) {
          return xcxUrl +
            `pages/gameCore/seekDistinct/seekDistinct.html%3F${pcParams}`;
        }
        // 预售有礼
        else if (row.subType == 27) {
          return xcxUrl +
            `pages/interactTask/preGift/preGift.html%3F${pcParams}`;
        }
        // 预售抽奖
        else if (row.subType == 28) {
          return xcxUrl +
            `pages/interactTask/prePrize/prePrize.html%3F${pcParams}`;
        }
        // 超级裂变
        else if (row.subType == 31) {
          return xcxUrl +
            `pages/interactTask/superCoupon/superCoupon.html%3F${pcParams}`;
        }
        // 加购有礼
        else if (row.subType == 34) {
          return xcxUrl +
            `pages/interactTask/addCart/addCart.html%3F${pcParams}`;
        }
        else if (row.subType == 13) {
          return "http://index.yeionsms.com/yidongd/index.html";
        }
        else if (row.subType == 14) {
          return "http://yq-hd-rc.isvjcloud.com/shop.html";
        }
        else if (row.subType == 36) {
          return xcxUrl +
            `pages/interactTask/orderRisk/orderRisk.html%3F${pcParams}`;
        }
        else if (row.subType == 37) {
          // 珀莱雅的活动单独处理，后续可能所有活动统一处理
          params1 = `activityId%3D${options.activityId}%26venderId%3D${options.venderId}%26activityType%3D${options.activityType}`;
          return xcxUrl +
            "pages/interactTask/sampleBuyback/sampleBuyback.html%3f" +
            params1;
        }
        // 红包
        else if (row.subType == 38) {
          return xcxUrl +
            `pages/integralStore/exchangeHb/exchangeHb.html%3F${pcParams}`;
        }
        // 生日有礼
        else if (row.subType == 39) {
          return xcxUrl +
            `pages/interactTask/birthGift/birthGift.html%3F${pcParams}`;
        }
        // 会员升级礼
        else if (row.subType == 44) {
          return xcxUrl +
            `pages/upgradeMember/upgradeMember.html%3F${pcParams}`;
        }
        // 晒单有礼
        else if (row.subType == 41) {
          // 同时设置pcUrl
          row.pcUrl = `${xcxUrl}pages/hwCustomize/hwCustomize.html%3F${pcParams}`;
          return xcxUrl +
            `pages/hwCustomize/hwCustomize.html%3F${pcParams}`;
        }
        // 积分锁权
        else if (row.subType == 45) {
          return xcxUrl +
            `pages/interactTask/newLockAuth/newLockAuth.html%3F${pcParams}`;
        }
        // 满额有礼
        else if (row.subType == 46) {
          return `${xcxUrl}pages/interactTask/purchaseGifts/purchaseGifts.html%3F${pcParams}`;
        }
        // 情书贺卡
        else if (row.subType == 50) {
          return `${xcxUrl}pages/loveLettersCards/loveLettersCards.html%3F${pcParams}`;
        }
        // 调查问卷
        else if (row.subType == 47) {
          return `${xcxUrl}pages/question/question.html%3F${pcParams}`;
        }
        // 定时开奖
        else if (row.subType == 48) {
          return `${xcxUrl}pages/timeOpenWin/timeOpenWin.html%3F${pcParams}`;
        }
        // 0元试用
        else if (row.subType == 51) {
          return `${xcxUrl}pages/onTrial/onTrial.html%3F${pcParams}`;
        }
        //试用回购礼
        else if (row.subType == 52) {
          return `${xcxUrl}pages_2/trialRepurchase/trialRepurchase.html%3F${pcParams}`
        }
        // 购物打卡
        else if (row.subType == 53) {
          return `${xcxUrl}pages/shopClock/shopClock.html%3F${pcParams}`
        }
        // 集卡有礼
        else if (row.subType == 62) {
          return `${xcxUrl}pages_2/collectCardsGifts/collectCardsGifts.html%3F${pcParams}`
        }
        else if (row.subType == 64) {
          return `${xcxUrl}pages_2/teamPrizes/teamPrizes.html%3F${pcParams}`
        }
       if (row.subType == 65) {
           return `${xcxUrl}pages_2/fansPunchCard/fansPunchCard.html%3F${pcParams}`
       }
       // 入会有礼
       else if (row.subType == 66) {
           return `${xcxUrl}pages_2/membershipBenefits/membershipBenefits.html%3F${pcParams}`
       }
       if (row.subType == 67) {
           return `${xcxUrl}pages_2/salesRanking/salesRanking.html%3F${pcParams}`
       }
       if (row.subType == 68) {
          return `${xcxUrl}pages_2/userLifecycle/userLifecycle.html%3F${pcParams}`
       }
       if (row.subType == 69) {
          return `${xcxUrl}pages_2/groupBookingCutprice/groupBookingCutprice.html%3F${pcParams}`
       }
       if (row.subType == 71) {
          return `${xcxUrl}pages_2/funGames/funGames.html%3F${pcParams}`
       }
      // 时光许愿池
      if (row.subType == 76) {
        return `${xcxUrl}pages_2/timeWishingPool/timeWishingPool.html%3F${pcParams}`
      }
      // 购物车锦鲤
      if (row.subType == 77) {
        return `${xcxUrl}pages_2/shopCardKoi/shopCardKoi.html%3F${pcParams}`
      }
      // 打包一口价
      if (row.subType == 78) {
        return `${xcxUrl}pages_2/packageFixedPrice/packageFixedPrice.html%3F${pcParams}`
      }
      // 盖楼有礼
      if (row.subType == 79) {
        return `${xcxUrl}pages_2/buildEtiquette/buildEtiquette.html%3F${pcParams}`
      }
      // 小红书晒单礼
      if (row.subType == 80) {
        return `${xcxUrl}pages_2/redBook/redBook.html%3F${pcParams}`
      }
      // 集分冲榜
      if (row.subType == 81) {
        return `${xcxUrl}pages_2/hsCustomer/hsCustomer.html%3F${pcParams}`
      }
      // 粉丝集分应援
      if (row.subType == 82) {
        return `${xcxUrl}pages_2/hsCustomization/hsCustomization.html%3F${pcParams}`
      }
      // 晒图pk
      if (row.subType == 83) {
        return `${xcxUrl}pages_2/showImageGift/showImageGift.html%3F${pcParams}`
      }
      // 日历打卡
      if (row.subType == 84) {
        return `${xcxUrl}pages_2/pictureClock/pictureClock.html%3F${pcParams}`
      }
      // 百变趣答
      if (row.subType == 85) {
        return `${xcxUrl}pages_2/answers/answers.html%3F${pcParams}`
      }
      if (row.subType == 87) {
        return `${xcxUrl}pages_2/quizShopGuide/quizShopGuide.html%3F${pcParams}`
      }
      // 积分兑换优惠券
      if (row.subType == 89) {
        return `${xcxUrl}pages_2/pointExchangeCoupon/pointExchangeCoupon.html%3F${pcParams}`
      }
        // 默认返回值
        return '';
      }
    }
  },
  watch: {
    createStep(newVal) {
      if (newVal != 1) {
        this.$emit("tabChange", false);
      } else {
        this.$emit("tabChange", true);
      }
    },
  },

  mounted() {
    // 默认打开草稿tab
    if (this.$route.query.isDarft) {
      this.handleTab(5);
    }
    if (this.$route.query.outId) {
      this.jdInit(this.$route.query.outId);
    }
    if (this.$route.query.activityType) {
      this.form.activityType = Number(this.$route.query.activityType);
      this.$forceUpdate();
    }
    this.prefixQue();
    this.getActivitySelect();
    //从京东调过来直接进入数据统计页面
    console.log("从京东调过来直接进入数据统计页面", this.$route.query.outId);
    // 晒单有礼新增库存提示
    this.getInventoryTip()
  },

  methods: {
    changeShop(val,row) {
      updateShopNameType({
        activityId: row.id,
        shopNameType: val
      }).then(res => {
        if (res.code == 1) {
          this.handleTabs(1,row)
          this.$message.success(res.message);
        }else{
          this.$message.error(res.message);
        }
      })
    },
    // 获取短链接
    urlChange(item, index){
      let params = {
           isJdApi:2,
           shortLinkType:1,
           isSmartLink:0,
           isPrecision:0,
           url:item
       }
      if(!item){
        return
       }
      getShortLink(params).then(res => {
        if (res.code == 1) {
           this.$set(this.activityList[index], 'shortLink', res.message);
        }
      })
    },
    getInventoryTip() {
      prizeStockWarningText().then((res) => {
        if (res.code == 1) {
          this.inventorytip = res.data || "";
        }
      });
    },
    getPrizeStockWarning(val) {
      if(val) {
        this.getInventoryTip()
      }
      this.isShowInventory = false
    },
    addInventoryTip(row) {
      this.activityInfo = row
      this.isShowInventory = true
    },
    //新增黑名单
    showAddBlacklistAdd(){
      this.showAddBlacklist = true;
      this.newBlacklistForm = {
          customerPin: '',
          orderIds: '',
          dataType: 0
      }
    },
    //删除黑名单
    delBlack(row){
      this.tableLoding = true;
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
       deleteBlacklist(row.id).then(res => {
        if (res.code == 1) {
          this.tableLoding = false;
          this.$message.success(res.message);
          this.refreshBlacklist()
        }else{
           this.tableLoding = false;
          this.$message.error(res.message);
        }
      })
      }).catch(() => {
         this.tableLoding = false;
      });
    },
    //编辑
    editBlack(row){
      this.showAddBlacklist = true;
      this.blackTitle = '编辑黑名单';
      this.blackLogo = false;
      this.newBlacklistForm = {...row}
    },
    //添加黑名单
    balck(row) {
      this.activeRow = row;
      this.blackTitle = '新增黑名单';
      this.blackLogo = true;
      this.refreshBlacklist()
      this.showBlacklist = true;
    },
    // 刷新黑名单列表
    refreshBlacklist() {
      //调用黑名单列表接口
      let params = {
        size: this.size,
        current: this.current,
        activityId:  this.activeRow.id,
        subType:  this.activeRow.activityType
      }
      getBlacklist(params).then(res => {
        if (res.code == 1) {
          this.tableLoding = false;
          this.blacklistData = res.data.records || [];
          this.totalRecord =Number(res.data.total)|| 0;
        }
      })
    },
    // 保存新增的黑名单
    saveAddBlacklist() {
      // 表单验证
      if (!this.newBlacklistForm.customerPin) {
        this.$message.warning('请输入用户PIN');
        return;
      }
      if (this.newBlacklistForm.dataType === 1 && !this.newBlacklistForm.orderIds) {
        this.$message.warning('请输入指定订单号');
        return;
      }
      this.newBlacklistForm.activityId = this.activeRow.id;
      this.newBlacklistForm.subType = this.activeRow.activityType;
      addBlacklist(this.newBlacklistForm).then(res => {
        if (res.code == 1) {
          this.$message.success(res.message);
          this.showAddBlacklist = false;
          this.newBlacklistForm = {
               customerPin: '',
               orderIds: '',
               dataType: 0
          }
          //刷新黑名单列表
          this.balck(this.activeRow);
        }else{
            this.$message.error(res.message);
        }
      })
    },
    // 黑名单分页查询事件
    handleBlacklistPages(page) {
      this.current = page.pageNum;
      this.size = page.pageSize;
      this.refreshBlacklist();
    },
    // 保存黑名单
    saveBlacklist() {
      this.$message.success('保存成功');
      this.showBlacklist = false;
    },
    // 处理订单类型变化
    handleOrderTypeChange() {
      // 当选择全部订单时，清空订单号
      if (this.newBlacklistForm.dataType === 0) {
        this.newBlacklistForm.orderIds = '';
      }
    },

    handlerActive(row) {
      this.activeRow = row;
      this.showPauseActive = true;
    },
    // 暂停/启动（大转盘抽奖）
    pauseActive() {
      const status = this.activeRow.status == 2 ? 6 : 0;
      let data = {
        id: this.activeRow.id,
        status: status,
      };
      activityUpdate(data).then((res) => {
        this.$message.success(`${status == 6 ? "暂停" : "启动"}成功`);
        this.showPauseActive = false;
        this.queryList();
      });
    },
    onNum(val) {
      console.log(val);

      let params = {
        id: val.id,
        priority: val.priority,
      };
      if (!val.priority) {
        this.$nextTick(() => {
          val.priority = val.oldPriority;
        });
        return this.$message.warning("优先级不能为空");
      }
      paradise(params).then((res) => {
        if (res.code == 1) {
          this.$message.success(res.message);
          this.queryList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 新版本切换
    triggerVersion(val) {
      this.isNew = val;
    },
    handleCreateByMe() {
      this.recordData.current = 1;
      this.handkeSearch(0);
    },
    getActivitySelect() {
      if (this.mainTypes == 1) {
        this.selectArr = [
          {
            value: "",
            label: "全部",
          }, 
          ...useActivityTypeList()
        ];
      } else if (this.mainTypes == 2) {
        this.selectArr = [
          {
            value: "",
            label: "全部",
          },
          {
            value: 13,
            label: "开卡礼包",
          },
          {
            value: 14,
            label: "店铺礼包",
          },
          {
            value: 15,
            label: "店铺礼包（千人千面）",
          },
          {
            value: 63,
            label: "BI店铺礼包",
          },
          {
            value: 74,
            label: "关注礼包",
          },
          {
            value: 75,
            label: "加购礼包",
          },
        ];
      }
    },

    clearTimeSendTime() {
      this.form.startTime = "";
      this.form.endTime = "";
    },

    clearUpdateTime() {
      this.form.endUpdateTime = "";
      this.form.startUpdateTime = "";
    },

    handleshow(row) {
      this.actItemInfo = row;
    },
    typeFilter(type) {
      if (
        this.form.activityPlusMainTypes == 6 ||
        this.form.activityPlusMainTypes == 7
      ) {
        return false;
      } else if ([14, 15, 63,74,75].includes(Number(type))) {
        // 14、15为店铺礼包，63为BI店铺礼包，进行中时不可修改
        return false;
      } else {
        return true;
      }
    },
    async jdInit(id) {
      const { data: item } = await activityDetail({
        id: id,
        activityType: 0,
      });
      this.rowData = item;
      this.ids1 = item.id;
      this.createStep = 3;
    },
    handleAnysis(row) {
      console.log(row);
      this.ids = row.id;
      if (row.type == 11) this.createStep = 11;
      if (row.type == 12) this.createStep = 12;
    },
    statisDataCreate(row) {
      this.rowData = row;
      this.ids1 = row.id;
      this.createStep = 3;
      this.handleshow(false);
    },
    handleTabs(i,e) {
      this.currIndexs = i;
      this.actLinkIds = e.id;
      this.recordData.current = 1;
      this.recordData.size = 10;
      const params = {
        activityId: e.id,
        size: 10,
        current: 1,
        type: i
      };
      this.tableLodingCurrIndexTwo = true;
      this.tableLodingCurrIndexOne = true;
      customSellerLinkPage(params).then((res) => {
        if (i === 1) {
          this.tableLodingCurrIndexOne = false;
          this.tableDatas = res.data.records;
          if(this.tableDatas.length > 0) {
            this.shopNameType = this.tableDatas[0].shopNameType;
          }
        } else if (i === 2) {
          this.tableLodingCurrIndexTwo = false;
          this.tableDatas2 = res.data.records;
        }
      });
    },
    handleTab(i) {
      this.currIndex = i;
      if (i == 0) this.form.status = "";
      if (i == 1) this.form.status = 2;
      if (i == 2) this.form.status = 1;
      if (i == 3) this.form.status = 3;
      if (i == 5) this.form.status = 5;
      if (i == 6) this.form.status = 6;
      // this.queryList();
      if (
        this.form.activityPlusMainTypes != 6 &&
        this.form.activityPlusMainTypes != 7
      )
        this.queryList();
      this.$nextTick(() => {
        if (this.form.activityPlusMainTypes == 6)
          this.$refs["giftList"].searchClick(this.form);
        if (this.form.activityPlusMainTypes == 7)
          this.$refs["member"].searchClick(this.form);
      });
    },
    handkeSearch(e, i) {
      this.recordData.current = 1;
      if (i == 1) {
        this.form.activityPlusMainTypes = 1;
        this.form.activityName = "";
        this.form.activityType = "";
        this.clearTimeSendTime();
        this.clearUpdateTime();
        this.$refs.formRef.reData();
      } else {
        this.form.activityName = e.activityName ? e.activityName : "";
        this.form.startTime = e.startTime ? e.startTime : "";
        this.form.endTime = e.endTime ? e.endTime : "";
        this.form.startUpdateTime = e.startUpdateTime ? e.startUpdateTime : "";
        this.form.endUpdateTime = e.endUpdateTime ? e.endUpdateTime : "";
      }
      this.activityPlusMainTypes = this.form.activityPlusMainTypes;
      if (
        this.form.activityPlusMainTypes != 6 &&
        this.form.activityPlusMainTypes != 7
      )
        this.queryList();
      this.$nextTick(() => {
        if (this.form.activityPlusMainTypes == 6)
          this.$refs["giftList"].searchClick(this.form);
        if (this.form.activityPlusMainTypes == 7)
          this.$refs["member"].searchClick(this.form);
      });
    },
    //时间拼装
    time() {
      let yy = new Date().getFullYear(); //当前年份
      let mm =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      let dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate(); //当前天数
      this.mytimestart = `${this.getDateStr(-30)} 00:00:00`;
      this.mytimeend = `${yy}-${mm}-${dd} 23:59:59`;
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    handleSrcImg(id, type='') {
      // 获取要下载的图片
      let img = document.querySelector(`#qrcode${id} img`);
      if(type=='channel') {
        img = document.querySelector(`#channelQrcodeDownload${id} img`);
      }else if(type=='self') {
        img = document.querySelector(`#selfQrcodeDownload${id} img`);
      }
      // 获取图片地址
      let url = img.src;
      // 创建一个a节点插入的document
      let a = document.createElement("a");
      // 模拟鼠标click点击事件
      let event = new MouseEvent("click");
      // 设置a节点的download属性值
      a.download = "huodongyulan";
      // 将图片的src赋值给a节点的href
      a.href = url;
      // 触发鼠标点击事件
      a.dispatchEvent(event);
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 200, // 设置宽度，单位像素
        height: 200, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
        src: "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/ee38b111bb964da7aeb7d67fe4317a51.png",
      });
    },
    //获取活动地址
    prefixQue() {
      prefixurl()
        .then((res) => {
          this.activityUrl = res.data.activityUrl;
          this.venderId = res.data.venderId;
          this.$store.state.venderId = res.data.venderId;
          if (this.$route.query.hasOwnProperty("type")) {
            if (this.$route.query.type == 0) {
              this.form.endTime =
                this.$getDate(1)[0].split(" ")[0] + " 23:59:59";
                this.searchFormInfo.forEach((item)=>{
                  if(item.label=="活动时间：") {
                    item.endTime =  this.form.endTime;
                  }
                })
                this.$refs.formRef.reData();
            }
            this.handleTab(this.$route.query.type);
          } else {
            this.queryList();
          }
        })
        .catch((res) => {});
    },
    //活动管理查询
    queryList() {
      this.talbeLoading = true;
      this.activityList.forEach((item, index) => {
        var ref = "qrcode" + item.id;
        this.$nextTick(() => {
          if (item.id && this.$refs[ref]) {
            this.$refs[ref].innerHTML = "";
          }
        });
      });
      this.talbeLoading = true;
      queryActivity({
        ...this.recordData,
        ...this.form,
        activityPlusMainTypes: this.mainTypes,
      }).then((res) => {
        this.talbeLoading = false;
        let { records = [], total = 0 } = res.data;
        let mesUrl = "";
        this.activityList = records.map((item) => {
          return {
            ...item,
            days: this.DayHours(item.startTime, item.endTime, item.status),
          };
        });
        this.totalNum = Number(total);
        this.activityList.forEach((item, index) => {
          item.oldPriority = item.priority;
          // 二维码进小程序
          let xcxUrl = this.$commonUrl();
          this.xcxUrl = this.$commonUrl();
          let options = {
            activityId: item.id,
            venderId: this.venderId,
            activityType: item.activityType,
          };
          let params1 = `%7B%22activityId%22%3A%22${options.activityId}%22%2C%22venderId%22%3A%22${options.venderId}%22%2C%22activityType%22%3A${options.activityType}%2C%22id%22%3A111%2C%22index%22%3A222%7D`;
          let pcParams = encodeURIComponent(
            Object.keys(options)
              .map((item) => `${item}=${options[item]}`)
              .join("&")
          );
          // 1：签到赢好礼
          if (item.activityType == 1) {
            item.idUrl =
              xcxUrl +
              `pages/interactTask/signPolite/signPolite.html%3F${pcParams}`
          }
          // 2：浏览礼品有礼
          // if (item.activityType == 2) {
          //   item.idUrl = ""
          // }
          // 3：每日抢好礼
          if (item.activityType == 3) {
            item.idUrl =
              xcxUrl +
              `pages/interactTask/robGoodPresent/robGoodPresent.html%3F${pcParams}`;
          }
          // 4：关注店铺有礼
          if (item.activityType == 4) {
            item.idUrl =
              xcxUrl +
              `pages/interactTask/attentionShop/attentionShop.html%3F${pcParams}`;
          }
          //  5：邀请开卡有礼
          if (item.activityType == 5) {
            item.idUrl =
              xcxUrl +
              `pages/interactTask/inviteCard/inviteCard.html%3F${pcParams}`;
            item.pcUrl = `${xcxUrl}pages/interactTask/inviteCard/inviteCard.html%3F${pcParams}`;
          }
          //  6：邀请关注店铺
          if (item.activityType == 6) {
            item.idUrl =
              xcxUrl +
              `pages/interactTask/invite/invite.html%3F${pcParams}`;
          }
          // 7：完善信息有礼
          if (item.activityType == 7) {
            item.idUrl =
              xcxUrl +
              `pages/interactTask/perfect_information/perfect_information.html%3F${pcParams}`;
          }
          //  8：幸运抽奖
          if (item.activityType == 8) {
            item.idUrl =
              xcxUrl +
              `pages/interactPark/bigTurntable/bigTurntable.html%3F${pcParams}`
          }
          //  京获客1.2 下单复购首购
          if (
            item.activityType == 16 ||
            item.activityType == 17 ||
            item.activityType == 18
          ) {
            item.idUrl =
              xcxUrl +
              `pages/interactTask/ordergift/ordergift.html%3F${pcParams}`;
            item.pcUrl = `${xcxUrl}pages/interactTask/ordergift/ordergift.html%3F${pcParams}`;
          }
          //  19：下单抽奖
          if (item.activityType == 19) {
            item.idUrl =
              xcxUrl +
              `pages/interactPark/placeOrder/placeOrder.html%3F${pcParams}`
          }
          //  京获客1.3 评价有礼
          if (item.activityType == 20) {
            item.idUrl =
              xcxUrl +
              `pages/interactTask/evaluation_gift/evaluation_gift.html%3F${pcParams}`;
          }
          //  京获客1.3 裂变神券
          if (item.activityType == 21) {
            item.idUrl =
              xcxUrl +
              `pages/interactTask/groupCoupon/groupCoupon.html%3F${pcParams}`;
          }
          //  京获客1.3 红包雨
          if (item.activityType == 22) {
            item.idUrl =
              xcxUrl +
              `pages/interactTask/redPacketRain/redPacketRain.html%3F${pcParams}`;
          }
          //  京获客1.4 疯狂抓娃娃
          if (item.activityType == 23) {
            item.idUrl =
              xcxUrl +
              `pages/gameCore/catchDoll/catchDoll.html%3F${pcParams}`;
          }
          //  京获客1.4 欢乐娃娃机
          if (item.activityType == 24) {
            item.idUrl =
              xcxUrl +
              `pages/gameCore/seekDistinct/seekDistinct.html%3F${pcParams}`;
          }
          //  预售有礼
          if (item.activityType == 27) {
            item.idUrl =
              xcxUrl +
              `pages/interactTask/preGift/preGift.html%3F${pcParams}`;
          }
          //  预售抽奖
          if (item.activityType == 28) {
            item.idUrl =
              xcxUrl +
              `pages/interactTask/prePrize/prePrize.html%3F${pcParams}`;
          }
          //  超级裂变
          if (item.activityType == 31) {
            item.idUrl =
              xcxUrl +
              `pages/interactTask/superCoupon/superCoupon.html%3F${pcParams}`;
          }
          // 加购有礼
          if (item.activityType == 34) {
            item.idUrl =
              xcxUrl +
              `pages/interactTask/addCart/addCart.html%3F${pcParams}`;
          }
          if (item.activityType == 13) {
            item.idUrl = "http://index.yeionsms.com/yidongd/index.html";
          }
          if (item.activityType == 14) {
            item.idUrl = "http://yq-hd-rc.isvjcloud.com/shop.html";
          }
          if (item.activityType == 36) {
            item.idUrl =
              xcxUrl +
              `pages/interactTask/orderRisk/orderRisk.html%3F${pcParams}`;
          }
          if (item.activityType == 37) {
            // 珀莱雅的活动单独处理，后续可能所有活动统一处理
            params1 = `activityId%3D${options.activityId}%26venderId%3D${options.venderId}%26activityType%3D${options.activityType}`;
            item.idUrl =
              xcxUrl +
              "pages/interactTask/sampleBuyback/sampleBuyback.html%3f" +
              params1;
          }
          //  红包
          if (item.activityType == 38) {
            item.idUrl =
              xcxUrl +
              `pages/integralStore/exchangeHb/exchangeHb.html%3F${pcParams}`;
          }
          // 生日有礼
          if (item.activityType == 39) {
            item.idUrl =
              xcxUrl +
              `pages/interactTask/birthGift/birthGift.html%3F${pcParams}`;
          }
          // 会员升级礼
          if (item.activityType == 44) {
            item.idUrl =
              xcxUrl +
              `pages/upgradeMember/upgradeMember.html%3F${pcParams}`;
          }
          // 晒单有礼
          if (item.activityType == 41) {
            item.idUrl =
              xcxUrl +
              `pages/hwCustomize/hwCustomize.html%3F${pcParams}`;
            item.pcUrl = `${xcxUrl}pages/hwCustomize/hwCustomize.html%3F${pcParams}`;
          }
          // 积分锁权
          if (item.activityType == 45) {
            item.idUrl =
              xcxUrl +
              `pages/interactTask/newLockAuth/newLockAuth.html%3F${pcParams}`;
          }
          // 满额有礼
          if (item.activityType == 46) {
            item.idUrl = `${xcxUrl}pages/interactTask/purchaseGifts/purchaseGifts.html%3F${pcParams}`;
          }
          // 情书贺卡
          if (item.activityType == 50) {
            item.idUrl = `${xcxUrl}pages/loveLettersCards/loveLettersCards.html%3F${pcParams}`;
          }
          // 调查问卷
          if (item.activityType == 47) {
            item.idUrl = `${xcxUrl}pages/question/question.html%3F${pcParams}`;
          }
          // 定时开奖
          if (item.activityType == 48) {
            item.idUrl = `${xcxUrl}pages/timeOpenWin/timeOpenWin.html%3F${pcParams}`;
          }
          // 0元试用
          if (item.activityType == 51) {
            item.idUrl = `${xcxUrl}pages/onTrial/onTrial.html%3F${pcParams}`;
          }
          //试用回购礼
          if (item.activityType == 52) {
            item.idUrl = `${xcxUrl}pages_2/trialRepurchase/trialRepurchase.html%3F${pcParams}`
          }
          // 购物打卡
          if (item.activityType == 53) {
            item.idUrl = `${xcxUrl}pages/shopClock/shopClock.html%3F${pcParams}`
          }
          // 集卡有礼
          if (item.activityType == 62) {
            item.idUrl = `${xcxUrl}pages_2/collectCardsGifts/collectCardsGifts.html%3F${pcParams}`
          }
          // 组队瓜分奖品
          if (item.activityType == 64) {
            item.idUrl = `${xcxUrl}pages_2/teamPrizes/teamPrizes.html%3F${pcParams}`
          }
          // 粉丝打卡
          if (item.activityType == 65) {
            item.idUrl = `${xcxUrl}pages_2/fansPunchCard/fansPunchCard.html%3F${pcParams}`
          }
          // 入会有礼
          if (item.activityType == 66) {
            item.idUrl = `${xcxUrl}pages_2/membershipBenefits/membershipBenefits.html%3F${pcParams}`
          }
          // 销售打榜
          if (item.activityType == 67) {
            item.idUrl = `${xcxUrl}pages_2/salesRanking/salesRanking.html%3F${pcParams}`
          }
          // 用户生命周期
          if (item.activityType == 68) {
            item.idUrl = `${xcxUrl}pages_2/userLifecycle/userLifecycle.html%3F${pcParams}`
          }
          // 拼团砍价
          if (item.activityType == 69) {
            item.idUrl = `${xcxUrl}pages_2/groupBookingCutprice/groupBookingCutprice.html%3F${pcParams}`
          }
          // 趣味游戏
          if (item.activityType == 71) {
            item.idUrl = `${xcxUrl}pages_2/funGames/funGames.html%3F${pcParams}`
          }
          // 时光许愿池
          if (item.activityType == 76) {
            item.idUrl = `${xcxUrl}pages_2/timeWishingPool/timeWishingPool.html%3F${pcParams}`
          }
          // 购物车锦鲤
          if (item.activityType == 77) {
            item.idUrl = `${xcxUrl}pages_2/shopCardKoi/shopCardKoi.html%3F${pcParams}`
          }
          // 打包一口价
          if (item.activityType == 78) {
            item.idUrl = `${xcxUrl}pages_2/packageFixedPrice/packageFixedPrice.html%3F${pcParams}`
          }
          // 盖楼有礼
          if (item.activityType == 79) {
            item.idUrl = `${xcxUrl}pages_2/buildEtiquette/buildEtiquette.html%3F${pcParams}`
          }
          // 小红书晒单礼
          if (item.activityType == 80) {
            item.idUrl = `${xcxUrl}pages_2/redBook/redBook.html%3F${pcParams}`
          }
          // 集分冲榜
          if (item.activityType == 81) {
            item.idUrl = `${xcxUrl}pages_2/hsCustomer/hsCustomer.html%3F${pcParams}`
          }
          // 粉丝集分应援
          if (item.activityType == 82) {
            item.idUrl = `${xcxUrl}pages_2/hsCustomization/hsCustomization.html%3F${pcParams}`
          }
          // 晒图pk
          if (item.activityType == 83) {
            item.idUrl = `${xcxUrl}pages_2/showImageGift/showImageGift.html%3F${pcParams}`
          }
          // 日历打卡
          if (item.activityType == 84) {
            item.idUrl = `${xcxUrl}pages_2/pictureClock/pictureClock.html%3F${pcParams}`
          }
          // 百变趣答
          if (item.activityType == 85) {
            item.idUrl = `${xcxUrl}pages_2/answers/answers.html%3F${pcParams}`
          }
          // 答题导购
          if (item.activityType == 87) {
            item.idUrl = `${xcxUrl}pages_2/quizShopGuide/quizShopGuide.html%3F${pcParams}`
          }
          // 积分兑换优惠券
          if (item.activityType == 89) {
            item.idUrl = `${xcxUrl}pages_2/pointExchangeCoupon/pointExchangeCoupon.html%3F${pcParams}`
          }
          // 获取短链接
          this.urlChange(item.pcUrl || item.idUrl, index);
        });
      });
    },

    //关闭弹框
    closehandleDelete() {
      this.outerVisible = false;
    },
    closehandleDeleteTwo() {
      this.outerVisibleTwo = false;
    },
    // 删除
    handleDeleteTableTwo() {
      if (this.status == 2) {
        this.$message.error("先结束活动再进行删除");
        this.outerVisibleTwo = false;
      } else {
        let id = this.ids;
        deleteEvent(id)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success("删除成功");
              this.outerVisibleTwo = false;
              this.queryList();
            }
          })
          .catch(() => {
            this.$message.error("删除失败");
          });
      }
    },
    //结束确定
    handleDeleteTable() {
      let id = this.ids;
      endEvent(id)
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success("操作成功");
            this.outerVisible = false;
            this.queryList();
          }
        })
        .catch(() => {
          if (res.code == 10100) {
            this.$message.error("活动未开始不能结束活动");
            this.outerVisible = false;
          } else {
            this.$message.error("操作失败");
          }
        });
    },
    returnStep() {
      console.log("返回》》》》》")
      this.createStep = 1;
      // this.recordData.current = 1;
      // this.recordData.size = 10;
      // // this.prefixQue();
      // this.$nextTick(() => {
      //   if (
      //     this.form.activityNewMainTypes != 6 &&
      //     this.form.activityNewMainTypes != 7
      //   )
      //     this.queryactivityPlusMainTypes
      //   if (this.foractivityPlusMainTypeses == 6)
      //     this.$refs["giftList"].searchClick(this.form);
      //   if (this.form.activityNewMainTypes == 7)
      //     this.$refs["activityPlusMainTypes(this.form);
      // });
      // console.log(thisactivityPlusMainTypes
    },
    createActivity(type,val) {
      // 用于生成二维码
      let coverSrc =
        "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://jdminiapp.yucrm.cn/html/images/Preview/";
      if (type == 5) {
        this.createStep = 5;
        this.activityData = {
          id: 4,
          name: "邀请开卡有礼",
          telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/cover/kk.png",
          telCode: coverSrc + "yqgz.png",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
        return;
      }
      if (type == 16 || type == 17 || type == 18) {
        this.createStep = 16;
        switch (type) {
          case 16:
            this.activityData = {
              id: 16,
              name: "下单有礼",
              telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/dingzhi.png",
              telCode: "",
              isCopy: this.isCopy,
              isStart: this.isStart,
              status: val.status,
            };
            this.titleName = "下单有礼";
            break;
          case 17:
            this.activityData = {
              id: 17,
              name: "首单专享礼",
              telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/dingzhi.png",
              telCode: "",
              isCopy: this.isCopy,
              isStart: this.isStart,
              status: val.status,
            };
            this.titleName = "首单专享礼";
            break;
          case 18:
            this.activityData = {
              id: 18,
              name: "复购有礼",
              telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/dingzhi.png",
              telCode: "",
              isCopy: this.isCopy,
              isStart: this.isStart,
              status: val.status,
            };
            this.titleName = "复购有礼";
            break;
        }
        return;
      }
      if (type == 27 || type == 28) {
        this.createStep = 27;
        switch (type) {
          case 27:
            this.activityData = {
              id: 27,
              name: "预售有礼",
              telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/dingzhi.png",
              telCode: "",
              isCopy: this.isCopy,
              isStart: this.isStart,
              status: val.status,
            };
            this.titleName = "预售有礼";
            break;
          case 28:
            this.activityData = {
              id: 28,
              name: "预售抽奖",
              telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/dingzhi.png",
              telCode: "",
              isCopy: this.isCopy,
              isStart: this.isStart,
              status: val.status,
            };
            this.titleName = "预售抽奖";
            break;
        }
        return;
      }
      if (type == 20 || type == 21 || type == 22) {
        this.createStep = 20;
        switch (type) {
          case 20:
            this.activityData = {
              id: 20,
              name: "评价有礼",
              telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/dingzhi.png",
              telCode: "",
              isCopy: this.isCopy,
              isStart: this.isStart,
              status: val.status,
            };
            this.titleName = "评价有礼";
            break;
          case 21:
            this.activityData = {
              id: 21,
              name: "裂变神券",
              telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/cover/lbsq.png",
              telCode: `https://yq-hd-rc.isvjcloud.com/clientPreview?venderId=${this.$store.state.loginUserInfo.venderId}&activityType=21`,
              isCopy: this.isCopy,
              isStart: this.isStart,
              status: val.status,
            };
            this.titleName = "裂变神券";
            break;
          case 22:
            this.activityData = {
              id: 22,
              name: "天降红包雨",
              telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/cover/tjhby.png",
              telCode: `https://yq-hd-rc.isvjcloud.com/clientPreview?venderId=${this.$store.state.loginUserInfo.venderId}&activityType=22`,
              isCopy: this.isCopy,
              isStart: this.isStart,
              status: val.status,
            };
            this.titleName = "天降红包雨";
            break;
        }
        return;
      }
      if (type == 15) {
        this.createStep = 15;
        this.activityData = {
          id: 15,
          name: "店铺礼包千人千面",
          telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/dingzhi.png",
          telCode: "",
          isCopy: this.isCopy,
          status: val.status,
        };
        this.titleName = "店铺礼包千人千面";
        return;
      }
      if (type == 36) {
        this.createStep = 36;
        this.activityData = {
          id: 36,
          name: "打榜有礼",
          telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/dingzhi.png",
          telCode: "",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
        this.titleName = "打榜有礼";
        return;
      }
      let idUrl1 = `https://yq-hd-rc.isvjcloud.com/clientPreview?activityType=11&venderId=${this.$store.state.loginUserInfo.venderId}`;
      this.createStep = 2;
      switch (type) {
        case 1:
          this.activityData = {
            id: 1,
            name: "签到赢好礼",
            telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/qdq.jpg",
            isCopy: this.isCopy,
            isStart: this.isStart,
            status: val.status,
          };
          break;
        case 3:
          this.activityData = {
            id: 3,
            name: "每日限时抢",
            telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/cover/mrq.png",
            telCode: `https://yq-hd-rc.isvjcloud.com/rob_goodPresent?venderId=${this.$store.state.loginUserInfo.venderId}`,
            isCopy: this.isCopy,
            isStart: this.isStart,
            status: val.status,
          };
          break;
        case 4:
          this.activityData = {
            id: 4,
            name: "关注店铺有礼",
            telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/cover/gzdp.png",
            telCode: `https://yq-hd-rc.isvjcloud.com/attention_shop?venderId=${this.$store.state.loginUserInfo.venderId}`,
            isCopy: this.isCopy,
            isStart: this.isStart,
            status: val.status,
          };
          break;
        case 5:
          this.activityData = {
            id: 4,
            name: "邀请开卡有礼",
            telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/kk.jpg",
            telCode: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/code.png",
            isCopy: this.isCopy,
            isStart: this.isStart,
            status: val.status,
          };
          break;
        case 6:
          this.activityData = {
            id: 6,
            name: "邀请关注有礼",
            telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/cover/yqgz.png",
            telCode: coverSrc + "yqkk.png",
            isCopy: this.isCopy,
            isStart: this.isStart,
            status: val.status,
          };
          break;
        case 7:
          this.activityData = {
            id: 7,
            name: "完善信息有礼",
            telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/cover/wsxx.png",
            telCode: `https://yq-hd-rc.isvjcloud.com/perfect_information?venderId=${this.$store.state.loginUserInfo.venderId}`,
            isCopy: this.isCopy,
            isStart: this.isStart,
            status: val.status,
          };
          break;
        case 13:
          this.activityData = {
            id: 13,
            name: "开卡礼包",
            isCopy: this.isCopy,
            status: val.status,
          };
          break;
        case 14:
          this.activityData = {
            id: 14,
            name: "店铺礼包",
            isCopy: this.isCopy,
            status: val.status,
          };
          break;
        case 63:
          this.createStep = 63;
          this.activityData = {
            id: 63,
            name: "BI店铺礼包",
            isCopy: this.isCopy,
            status: val.status,
          };
          break;
          case 74:
          this.createStep = 74;
          this.activityData = {
            id: 74,
            name: "关注礼包",
            isCopy: this.isCopy,
            status: val.status,
          };
          break;
          case 75:
          this.createStep = 75;
          this.activityData = {
            id: 75,
            name: "加购礼包",
            isCopy: this.isCopy,
            status: val.status,
          };
          break;
        case 34:
          this.activityData = {
            id: 34,
            name: "加购有礼",
            isCopy: this.isCopy,
            isStart: this.isStart,
            status: val.status,
          };
          break;
        
      }
    },
    returnBackChange(update) {
      this.createStep = 1;
      if (update) {
        this.queryList();
        this.returnStep();
      }
    },
    saveEditChange() {
      this.createStep = 1;
      this.tabActive = 2;
      this.changeStatus();
      setTimeout(() => {
        this.queryList();
      }, 1000);
    },

    // 表单查询
    searchForm(form) {
      this.recordData.current = 1;
      this.recordData.activityName = form.activityName;
      this.recordData.activityType = form.activityType;
      this.recordData.startTime = form.startTime;
      this.recordData.endTime = form.endTime;
      this.recordData.startUpdateTime = form.startUpdateTime;
      this.recordData.endUpdateTime = form.endUpdateTime;
      this.recordData.status = form.status;
      console.log("form:", this.recordData);
      this.queryList();
    },

    // 分页查询事件
    handlePages(page) {
      this.recordData.current = page.pageNum;
      this.recordData.size = page.pageSize;
      this.queryList();
    },
    //结束活动
    endenActivity(id) {
      this.outerVisible = true;
      this.ids = id;
    },

    //删除活动
    deleteActivity(id) {
      this.status = id.status;
      this.outerVisibleTwo = true;
      this.ids = id.id;
    },
    //修改
    modify(row, val, type = "edit", status) {
      // type==edit 为修改
      this.backgroundOpacity = type == "look" ? true : false;
      // 进行中的活动  去掉保存按钮
      // copy复制   复制需要跳转至选择模板页面
      this.stepNum = type == "copy" ? 0 : 1;
      this.isCopy = type == "copy" ? true : false;
      this.isDraftEdit = type == "draft" ? true : false;
      // V2.5需求  进行中活动可修改  复制不影响
      // 5.16 新增开卡礼包活动中可修改
      // BI店铺礼包(63)在进行中时不可修改
      if (status == 2 && type == "edit" && !([14, 15, 63,74,75].includes(Number(row)))) {
        this.isStart = true;
      } else {
        this.isStart = false;
      }
      if (type != "copy") {
        if (row == 20) {
          this.isSave = false;
          this.statusComment = true;
        } else {
          this.isSave = true;
        }
      }
      if (row == 8) {
        this.activityDataTwo = {
          telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/night_m.png",
          telCode: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/code.png",
          id: 8,
          name: "幸运抽奖",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
        this.createStep = 4;
        // this.stepNum = 1;
        this.ids = val.id;
      } else if (row == 19) {
        this.activityDataTwo = {
          telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/night_m.png",
          telCode: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/code.png",
          id: 19,
          name: "下单抽奖",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
        this.createStep = 19;
        this.ids = val.id;
      } else if (row == 23 || row == 24) {
        this.activityData = {
          telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/night_m.png",
          telCode: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/code.png",
          id: row,
          name: row == 23 ? "欢乐娃娃机" : "大家来找茬",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
        this.createStep = 23;
        this.valueRow = val;
        this.activeValue = row;
      } else if (row == 15) {
        this.createStep = 15;
        this.createActivity(row,val);
        this.valueRow = val;
        this.activeValue = row;
      } else if (row == 16 || row == 17 || row == 18) {
        this.createStep = 16;
        this.createActivity(row,val);
        this.valueRow = val;
        this.activeValue = row;
      } else if (row == 20 || row == 21 || row == 22) {
        this.createStep = 20;
        this.createActivity(row,val);
        this.valueRow = val;
        this.activeValue = row;
      } else if (row == 27 || row == 28) {
        this.createStep = 27;
        this.createActivity(row,val);
        this.valueRow = val;
        this.activeValue = row;
      } else if (row == 31) {
        this.createStep = 31;
        this.valueRow = val;
        this.activeValue = row;
        this.activityData = {
          id: 31,
          name: "超级裂变券",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
      } else if (row == 39) {
        console.log("--- row:---", row);
        this.createStep = 39;
        this.valueRow = val;
        this.activeValue = row;
        this.activityData = {
          id: 39,
          name: "生日有礼",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
      } else if (row == 41) {
        this.createStep = 41;
        this.valueRow = val;
        this.activeValue = row;
        this.activityData = {
          id: 41,
          name: "晒单有礼",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
      } else if (row === 43) {
        this.createStep = 43;
        this.valueRow = val;
        this.activeValue = row;
        this.activityData = {
          id: 43,
          name: "N元锁权",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
      } else if (row === 44) {
        this.createStep = 44;
        this.valueRow = val;
        this.activeValue = row;
        this.activityData = {
          id: 44,
          name: "会员升级礼",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
      } else if (row === 46) {
        this.createStep = 46;
        this.valueRow = val;
        this.activeValue = row;
        this.activityData = {
          id: 46,
          name: "满额有礼",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
      } else if (row === 45) {
        this.createStep = 45;
        this.valueRow = val;
        this.activityData = {
          id: 45,
          name: "锁权有礼",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
      } else if (row === 50) {
        this.createStep = 50;
        this.valueRow = val;
        this.activeValue = row;
        this.activityData = {
          id: 50,
          name: "情书贺卡",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
      } else if (row === 52){//试用回购礼    
        this.createStep = 52;
        this.valueRow = val;
        this.activityData = {
          id: 52,
          name: "试用回购礼",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
      } else if (row === 47) {
        this.createStep = 47;
        this.valueRow = val;
        this.activityData = {
          id: 47,
          name: "调查问卷",
          isCopy: this.isCopy,
          isStart: this.isStart,
          status: val.status,
        };
      } else if (row === 48) {
        this.createStep = 48;
        this.valueRow = val;
        this.activityData = {
          id: 48,
          name: "定时开奖",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      } else if (row === 51) {
        this.createStep = 51;
        this.valueRow = val;
        this.activityData = {
          id: 51,
          name: "0元试用",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      } else if (row === 53){        
        this.createStep = 53;
        this.valueRow = val;
        this.activityData = {
          id: 53,
          name: "购物打卡",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      } else if (row === 62){        
        this.createStep = 62;
        this.valueRow = val;
        this.activityData = {
          id: 62,
          name: "集卡有礼",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      } else if (row === 64){        
        this.createStep = 64;
        this.valueRow = val;
        this.activityData = {
          id: 64,
          name: "组队瓜分奖品",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      } else if (row === 65){        
        this.createStep = 65;
        this.valueRow = val;
        this.activityData = {
          id: 65,
          name: "粉丝打卡",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };

      } else if (row === 66){        
        this.createStep = 66;
        this.valueRow = val;
        this.activityData = {
          id: 66,
          name: "入会有礼",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        }
      } else if (row === 63){        
        this.createStep = 63
        this.createActivity(row,val);
        this.valueRow = val;
        this.activeValue = row;
      } else if (row === 74){        
        this.createStep = 74
        this.createActivity(row,val);
        this.valueRow = val;
        this.activeValue = row;
      } else if (row === 75){        
        this.createStep = 75
        this.createActivity(row,val);
        this.valueRow = val;
        this.activeValue = row;
      }
       else if (row === 67){        
        this.createStep = 67;
        this.valueRow = val;
        this.activityData = {
          id: 67,
          name: "销售打榜",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      } else if (row === 68){        
        this.createStep = 68;
        this.valueRow = val;
        this.activityData = {
          id: 68,
          name: "会员成长计划",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      } else if (row === 69){        
        this.createStep = 69;
        this.valueRow = val;
        this.activityData = {
          id: 69,
          name: "拼团砍价",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      }  else if (row === 71){        
        this.createStep = 71;
        this.valueRow = val;
        this.activityData = {
          id: 71,
          name: "趣味游戏",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      } else if (row === 76){        
        this.createStep = 76;
        this.valueRow = val;
        this.activityData = {
          id: 76,
          name: "时光许愿池",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      } 
      // 购物车锦鲤
      else if (row === 77){        
        this.createStep = 77;
        this.valueRow = val;
        this.activityData = {
          id: 77,
          name: "购物车锦鲤",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      }
      // 打包一口价
      else if (row === 78){        
        this.createStep = 78;
        this.valueRow = val;
        this.activityData = {
          id: 78,
          name: "打包一口价",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      } 
      // 盖楼有礼
      else if (row === 79){        
        this.createStep = 79;
        this.valueRow = val;
        this.activityData = {
          id: 79,
          name: "盖楼有礼",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      }
      // 小红书晒单礼
      else if (row === 80){        
        this.createStep = 80;
        this.valueRow = val;
        this.activityData = {
          id: 80,
          name: "小红书晒单礼",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      }
      // 集分冲榜
      else if (row === 81){        
        this.createStep = 81;
        this.valueRow = val;
        this.activityData = {
          id: 81,
          name: "集分冲榜",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      }
      // 粉丝集分应援
      else if(row===82) {
        this.createStep = 82;
        this.valueRow = val;
        this.activityData = {
          id: 82,
          name: "粉丝集分应援",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      }

      // 晒图pk
      else if (row === 83){        
        this.createStep = 83;
        this.valueRow = val;
        this.activityData = {
          id: 83,
          name: "晒图pk",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      }

      // 日历打卡
      else if(row===84) {
        this.createStep = 84;
        this.valueRow = val;
        this.activityData = {
          id: 84,
          name: "日历打卡",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        }
      }
      // 百变趣答
      else if (row === 85){        
        this.createStep = 85;
        this.valueRow = val;
        this.activityData = {
          id: 85,
          name: "百变趣答",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      }
      else if (row == 87){        
        this.createStep = 87;
        this.valueRow = val;
        this.activityData = {
          id: 87,
          name: "答题导购",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      }
      else if (row === 89){        
        this.createStep = 89;
        this.valueRow = val;
        this.activityData = {
          id: 89,
          name: "积分兑换优惠券",
          isCopy: this.isCopy,
          status: val.status,
          isStart: this.isStart,
        };
      }
      else {
        this.createStep = 2;
        this.createActivity(row,val);
        this.valueRow = val;
        this.activeValue = row;
      }
      this.$emit("changeData");
    },
    changeStatus() {
      this.$emit("changeStatus");
    },
    //数据统计
    statisData(row) {
      this.rowData = row;
      this.ids1 = row.id;
      if (row.activityType === 43) {
        // N元锁权
        this.createStep = 433;
      } else {
        this.createStep = 3;
      }
      // 判断活动时间是否为新版
      this.isNew = this.isCurrentTimeAfter(row.createTime);
    },
    handleback(type) {
      this.$emit("goback", type);
    },
    // 二维码预览
    async handleMouseover(row, index) {
      if (row.activityType == "15") {
        const { data: res } = await thousandGiftDetail(row.id);
        const prizesllist =
          res.sceneList.length > 0 ? res.sceneList[0].prizes : "";
        const prizes = prizesllist.map((item) => {
          return { title: item.title };
        });
        const giftTemplateUrl =
          res.sceneList.length > 0 ? res.sceneList[0].giftTemplateUrl : "";
        const buttonText =
          res.sceneList.length > 0 && res.sceneList[0].buttonText
            ? res.sceneList[0].buttonText
            : "";
        const text1 = `http://yq-hd-rc.isvjcloud.com/shop.html?image=${giftTemplateUrl}buttom=${encodeURIComponent(
          JSON.stringify(buttonText)
        )}text=${encodeURIComponent(JSON.stringify(prizes))}`;
        this.activityList = this.activityList.map((item) => {
          if (row.id == item.id) {
            item.idUrl = text1;
          }
          return item;
        });
        this.activityList = this.activityList.map((item) => {
          if (item.id == row.id) {
            item.idUrl = text1;
          }
          return item;
        });
      } else {
        const { data: res } = await giftBagEide(row.id);
        const prizes = res.prizes ? res.prizes : "";
        const giftTemplateUrl = res.giftTemplateUrl ? res.giftTemplateUrl : "";
        const buttonText =
          res.ruleDto && res.ruleDto.buttonText ? res.ruleDto.buttonText : "";
        const text = `http://index.yeionsms.com/yidongd/index.html?image=${giftTemplateUrl}`;
        const text1 = `http://yq-hd-rc.isvjcloud.com/shop.html?image=${giftTemplateUrl}buttom=${encodeURIComponent(
          JSON.stringify(buttonText)
        )}text=${encodeURIComponent(JSON.stringify(prizes))}`;
        this.activityList = this.activityList.map((item) => {
          if (row.id == item.id) {
            item.idUrl = row.activityType == "13" ? text : text1;
          }
          return item;
        });
        this.activityList = this.activityList.map((item) => {
          if (item.id == row.id) {
            item.idUrl = item.activityType == "13" ? text : text1;
          }
          return item;
        });
      }
    },
    DayHours(start, end, status) {
      let nowTime = this.formatDate(new Date());
      let res = "";
      // 未开始
      if (status == 1) {
        let arr = this.timediff(start, nowTime);
        res = arr[0] + "天" + arr[1] + "小时" + arr[2] + "分后开始";
      }
      // 进行中
      if (status == 2) {
        let arr = this.timediff(start, nowTime);
        res = "活动持续了" + arr[0] + "天" + arr[1] + "小时" + arr[2] + "分";
      }
      // 已结束
      if (status == 3) {
        let arr = this.timediff(start, end);
        res = "活动持续了" + arr[0] + "天" + arr[1] + "小时" + arr[2] + "分";
      }
      return res;
    },
    timediff(begin_time, end_time) {
      //年月日时分秒转换为时间戳
      let beginTime = new Date(begin_time).getTime() / 1000;
      let endTime = new Date(end_time).getTime() / 1000;
      var starttime = "";
      var endtime = "";
      if (beginTime < endTime) {
        starttime = beginTime;
        endtime = endTime;
      } else {
        starttime = endTime;
        endtime = beginTime;
      }
      //计算天数
      var timediff = endtime - starttime;
      var days = parseInt(timediff / 86400);
      //计算小时数
      var remain = timediff % 86400;
      var hours = parseInt(remain / 3600);
      //计算分钟数
      var remain = remain % 3600;
      var mins = parseInt(remain / 60);
      // var res = days + "天" + hours + "小时" + mins + "分";
      return [days, hours, mins];
    },
    formatDate(date, fmt = "yyyy-MM-dd hh:mm:ss") {
      let currentDate = new Date(date);
      let o = {
        "M+": currentDate.getMonth() + 1, //月份
        "d+": currentDate.getDate(), //日
        "h+": currentDate.getHours(), //小时
        "m+": currentDate.getMinutes(), //分
        "s+": currentDate.getSeconds(), //秒
        "q+": Math.floor((currentDate.getMonth() + 3) / 3), //季度
        S: currentDate.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (currentDate.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return fmt;
    },
    // 打开弹窗获取配置
    handleSetConfig() {
      this.$emit("changeTab", "mutualExclusion")
      // this.isShowActivityConfig = true;
      // this.getActivityConfig();
    },
    //保存配置
    handleConfirmConfig() {
      this.isShowActivityConfig = false;
      saveActivitySetting(this.activityConfig)
        .then((res) => {
          this.$message.success("保存成功");
        })
        .catch(() => {
          this.$message.error("保存失败");
        });
    },
    beforeConfigclose() {
      this.isShowActivityConfig = false;
    },
    //获取活动配置
    getActivityConfig() {
      this.configLoading = true;
      getActivitySetting({ activityType: 0 })
        .then((res) => {
          if (res.data && "checkExistOrder" in res.data) {
            let { checkExistOrder, id } = res.data;
            this.activityConfig.checkExistOrder = checkExistOrder;
            this.activityConfig.id = id;
          }
        })
        .catch(() => {
          this.$message.error("获取失败");
        })
        .finally(() => {
          this.configLoading = false;
        });
    },
    // 下单抽奖添加白名单
    addWhiteList(row) {
      this.whiteRow = row;
      this.showWhiteList = true;
    },
    // 编辑草稿箱
    editDraft(row) {
      this.modify(row.activityType, row, "draft", 5);
    },
    // 删除草稿箱
    delDraft(row) {
      this.status = row.status;
      this.ids = row.id;
      this.outerVisibleTwo = true;
    },
    returnBack() {
      this.createStep = 1;
    },
    // 中奖查询
    handleWinSearch() {
      this.createStep = 500;
    },
    // 复制店铺渠道链接
    copyChannelUrl(url) {
      this.$copyText(url).then(() => {
        this.$message.success("复制成功");
      });
    },
    // 添加渠道链接
    handleAddChannel(type) {
      this.channelName = '';
      this.addChannelVisible = true;
      this.addChanneltype = type;
    },
    // 渠道链接保存
    handleChannelSave() {
      if (!this.channelName) {
        this.$message.warning("请填写渠道名称!");
        return;
      }
      this.addChannelLoading = true
      let params = {
        sellerLinkName: this.channelName, // 名称
        activityId: this.actLinkIds?this.actLinkIds:'',
      }
      customSellerLinkSave(params).then((res)=>{
        this.addChannelLoading = false
        if(res.code === 1){
          this.$message.success("添加成功");
          this.addChannelVisible = false;
          // this.getChannelList();
        }else{
          this.$message.error(res.message);
        }
      })
    },
    handlerMouseEnter(){
      this.currIndexs = 0;
    },
    showCannel(type, settingType = 0) {
      // 放开所有活动的店铺渠道链接和自定义渠道链接
      // settingType 当活动仅设置了当前店铺时，也不会展示店铺渠道链接和自定义渠道链接
      return settingType === 0;
    },
    showQrcodeDialog(row) {
      this.qrcodePreviewData = {
        url: this.getLinkUrl(row),
        logo: this.qrcodeVue.logo,
        bgColor: this.qrcodeVue.bgColor,
        fgColor: this.qrcodeVue.fgColor,
      };
      this.qrcodeDialogVisible = true;
    },
    // 获取弹窗宽度
    getPopoverWidth(type) {
      // 所有活动都使用800px宽度以适配渠道链接显示
      return 800;
    },
    getInputWidth(type) {
      // 所有活动都使用503px宽度以适配渠道链接显示
      return 503;
    },
    handleAIResource() {
      this.isShowAIResource = true;
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dropdown-menu--small {
  padding: 6px 0 !important;
}

.my_select_time {
  display: flex;
  align-items: center;
}

.formClass {
  margin: 24px 0;
  display: flex;
  /deep/.el-form-item {
    margin-right: 50px;
  }
}

.seach_btn {
  float: right;
}

.search {
  margin-right: 8px;
  background: rgba(39, 104, 255, 0.1);
  color: #2768ff;
  border-radius: 2px;
  border: 0px;
  padding: 6px 20px;
  &:hover {
    color: #5286ff;
    background: rgba(39, 104, 255, 0.1);
  }
}
.reset {
  background: #f2f3f5;
  color: #666666;
  padding: 6px 20px;
  border: 0px;
  &:hover {
    background: #f2f3f5;
    color: #000;
  }
}

.tabSwitch {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  // padding: 0 20px;
  position: relative;
  height: 50px;
  font-size: 14px;
  color: #666;
  border-bottom: 1px solid #f6f6f6;
  &-wz {
    height: 50px;
    line-height: 50px;
    position: relative;
    margin-right: 24px;
    cursor: pointer;
    transition: all 0.2s;
  }
  .active {
    color: #fe4d45;
    &::before {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 100%;
      height: 2px;
      background-color: #fe4d45;
      transition: all 0.2s;
      animation: opation 0.2s;
    }
    @keyframes opation {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 100%;
      }
    }
  }
}
.createbox {
  width: 94px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 2px;
  border: 1px solid #fe4d45;
  cursor: pointer;
  outline: none;
  transition: all 0.2s;
  color: #fff;
  background-color: #fe4d45;
  &:hover {
    opacity: 0.8;
  }
}
.topbox {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #000;
}
.activityManage {
  box-sizing: border-box;
  height: 100%;
  // background: #fff;
  // padding: 0 24px 24px;
  &-list {
    height: 100%;
    &-scroll {
      height: calc(100% - 58px);
      overflow: auto;
    }
  }
  .activityName {
    display: flex;
    align-items: center;
    font-size: 14px;
    .code {
      margin-left: 8px;
      cursor: pointer;
      width: 20px;
      height: 20px;
      margin-top: 6px;
    }
    .act-name {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; //设置超出几行省略内容 
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 12px;
    }
  }
  .activityTime {
    display: flex;
    flex-direction: column;
  }
  .activityTime2 {
    display: flex;
    align-items: center;
    &_line {
      margin: 0px 10px;
    }
  }
  .state {
    padding: 6px 10px;
    border-radius: 17px;
  }
  .y1 {
    color: #666666;
    // background-color: #e6f7ff;
  }
  .y2 {
    color: #666666;
    // background: #fef1ec;
  }
  .y3 {
    color: #666666;
    // background: #f1f1f1;
  }
  .y-icon {
    width: 14px;
    height: 14px;
    margin-top: 2px;
    // margin-right: 3px;
    float: left;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .editList {
    width: 100%;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    text-align: left;
    span {
      // flex: 1;
      min-width: 28px;
      cursor: pointer;
      font-size: 14px;
    }
    .edit,
    .count {
      cursor: pointer;
      color: #2768ff;
      // &:hover {
      //   color: #fe4d45;
      // }
    }
    .end,
    .delete {
      cursor: pointer;
      color: #2768ff;
      text-align: center;
      &:hover {
        color: #5286ff;
      }
    }
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
.buttonBox {
  margin-top: 6px;
  .b1 {
    width: 98px;
    height: 32px;
    color: #666666;
    // position: absolute;
    border-radius: 3px;
    margin-top: 20px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .b2 {
    width: 98px;
    height: 32px;
    margin: 20px 80px 10px 10px;
    border: 1px solid #fe4d45;
    color: #ffffff;
    border-radius: 3px;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}

.menu-item {
  padding: 0 20px;
}
::v-deep .el-dropdown-menu__item,
.el-menu-item {
  padding: 0 !important;
}
.mt16 {
  margin-top: 16px;
}

.fs12 {
  font-size: $main-size !important;
}

.mr4 {
  margin-right: 4px;
}

.w260 {
  width: 260px;
}

.tip-style {
  color: #FF6207;
}

.channelBox {
  height: 356px;
  overflow: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 和 Edge */
}

.channelBox::-webkit-scrollbar {
  display: none;
}

/* 二维码容器 */
.qrcode-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

/* 遮罩层 */
.qrcode-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

/* 放大镜图标 */
.qrcode-zoom-icon {
  font-size: 24px;
  color: white;
}

/* 二维码弹窗样式 */
.el-dialog__body {
  padding: 20px;
}
.inventory-tip {
  color: #fe4d45;
}
.ai-wrap {
  display: flex;
  align-items: center;
  ::v-deep .ai-btn {
    margin-left: 12px;
  }
}
</style>
